var __endLoadTime = false
let clearflag = false;
let scrollCount = 0;
setTimeout(() => { __endLoadTime = true }, 20000)

$(function() {
  let url = new URL(window.location.href);
  let pathName = url.pathname;
  let menu_item = url && url.searchParams ? url.searchParams.get('menuitem') || url.searchParams.get('menuItemLink') : null;
  if(menu_item){
    let $elem = $('html, body').find('.link-'+menu_item);
    let header_height = $('#header').height();

    if($elem.length){
      setTimeout(()=> {
        $('html, body').animate({
          scrollTop: $elem.parents(".menu-section").offset().top
        }, 0)
        setTimeout(()=> {
          $('html, body').animate({
            scrollTop: $elem.offset().top - header_height-180
          }, 0);
        }, 500)
      }, 500)

      window.history.replaceState({}, document.title, pathName);
    }
  }

  var tab = get("tab");
  if(tab === "collapserevenueshare"){
      setTimeout(function(){
          $('.open-restaurant-about').trigger('click');
          $('a[href="#collapserevenueshare"]').trigger('click');
          $('html, body').animate({
              scrollTop : $('a[href="#collapserevenueshare"]').offset().top},'slow');   
      }, 1000);
  }

  function get(name){
    if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
     return decodeURIComponent(name[1]);
  }
})



var PROFILE = $('#account-infor').text()
try{
  PROFILE = JSON.parse(PROFILE)
}catch(err){
  PROFILE= {}
}
var USER_ROLES = $('#user-roles').text()
try{
  USER_ROLES = JSON.parse(USER_ROLES)
}catch(err){
  USER_ROLES = []
}

//set the slug if menuitem in url
let url = new URL(window.location.href);
const menu_item_slug = url.searchParams ? url.searchParams.get('menuItem'): null;
let scroll_to_menuitem_key = null; //this menuItemId gets updated from ejs when menu_item_slug = ejs slug

var ALL_FLAVOR_MATCH={};
let CHECK_SHOW_MODAL_ORDER = false;
/* redesign this is got from backend and  not called from frontend
window.get_all_flavor_match = function() {
  $.ajax({
    url: '/get-all-flavor-match',
    method: 'POST',
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({venueId: $('#venue-id').text().trim() }),
    dataType: 'json',
    error: ()=> {
      return false;
    }
  })
  .then( (data) => {
    ALL_FLAVOR_MATCH = data;
    //return render_flavor_match();
  })
}
*/

const columnDefined = {
  'rating': 1,
  'taste': 2,
  'discount': 3,
  'price': 4,
  'highestprice': 5,
  'meetpre':6
};

var sortFunction = function(_sortBy, a, b, nodetree=false) {
  let result_a = 1;
  let result_b = 1;
  for (let i = 0; i< _sortBy.length; i++){
    const field = _sortBy[i];
    if(Object.keys(columnDefined).indexOf(field) !== -1){
      if (field == 'rating'){
        result_a += getRating(a,nodetree);
        result_b += getRating(b,nodetree);
      }
      else if (field == 'taste'){
        result_a += getTaste(a,nodetree);
        result_b += getTaste(b,nodetree);
      }

      else if (field == 'meetpre'){
        result_a += getMeetpre(a,nodetree);
        result_b += getMeetpre(b,nodetree);
      }

      else if (field == 'discount'){
        let discount_a = getDiscount(a,nodetree);
        let discount_b = getDiscount(b,nodetree);
        result_a += discount_a;
        result_b += discount_b;
      }
      else if (field == 'price'){
      //if single sort by price, then dont apply max of 100, use max of 9999999
        let max = 9999999;
        if(_sortBy.length>1){
          max = 100
        }
        let price_a = getPrice(a,nodetree);
        let price_b = getPrice(b,nodetree);
        price_a = Math.max(max - price_a,0);
        price_b = Math.max(max - price_b,0);
        result_a += price_a;
        result_b += price_b;
      }
      else if(field == 'highestprice'){
        let max = 9999999;
        if(_sortBy.length>1){
          max = 100
        }
        let price_a = getPrice(a,nodetree);
        let price_b = getPrice(b,nodetree);
        price_a = Math.min(max,price_a);
        price_b = Math.min(max,price_b);
        //console.log("highest price_a..",price_a);
        //console.log("highest price_b..",price_b);
        result_a += price_a;
        result_b += price_b;
      }
    }
  }
  return (result_b - result_a);
}


//if taste <0, return 1; assuming 100% match then
//if none found, assume 100
var getTaste = function(x,nodetree){
  let taste=0;
  let tastex = 0 ;
  tastex = Number(x.flavorMatchitem);
  //console.log("taste..",taste);
if(tastex > 0){
    taste=tastex;
  }

  return taste ;
}

var getMeetpre = function(x,nodetree){
  let meet=0;
  let meetex = 0;
  meetex = Number(x.meets_preferences); //this for favorites on load

if(meetex > 0){
    meet=meetex;
  }

  return meet ;
}


var getDiscount = function(x,nodetree){
  let disc=0;
  let discx=0;
   discx = Number(x.discount);
  if(discx > 0){
    disc=discx;
  }
  //console.log("discount..",disc);
  return disc ;
}

var getPrice = function(x,nodetree){
  let price = 0;
  if(x.price) price=x.price;
  if(price && price.toString().endsWith("+")){
    price = Number(price.toString().replace("+",""))+1
  }
  else if(price && price.toString().includes("-")) { //    $14.50 - $29.50
    let pricearr= price.toString().split("-");
    if(pricearr && pricearr.length > 1){
      price = Number(pricearr[0])
    }
  }
  return Number(price);
}

const validateHoursMenus = (menuHours) => {
  let enableTime = true;
  if (menuHours && !menuHours.anyTime) {
    const current_date = new Date();
    const DAYS_OF_THE_WEEK = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const today = current_date.getDay();
    const index_day = DAYS_OF_THE_WEEK[today];

    const day = menuHours && menuHours.days ? menuHours.days[index_day] : null;

    if (day && day.fromTime && day.toTime) {
      const time_to_minute = function (time_convert = "00:00am") {
        time_convert = time_convert.toLowerCase();
        let [hours, minutesPart] = time_convert.split(":");
        let minutes = parseInt(minutesPart.substring(0, 2), 10);
        let period = minutesPart.slice(-2); // 'am' or 'pm'
        hours = parseInt(hours, 10);

        // Convert 12 AM to 0 hours and 12 PM to 12 hours
        if (period === "pm" && hours !== 12) {
          hours += 12; // Convert PM hours to 24-hour format
        }
        if (period === "am" && hours === 12) {
          hours = 0; // Midnight case
        }

        return hours * 60 + minutes; // Total minutes
      };

      const available_fromTime = time_to_minute(day.fromTime);
      const available_toTime = time_to_minute(day.toTime);
      const current_time = current_date.getHours() * 60 + current_date.getMinutes();

      // Validate if the current time falls within the available window
      if (!(available_fromTime <= current_time && current_time <= available_toTime)) {
        enableTime = false;
      }
    }
  }
  return enableTime;
};

//To validate menu is available or not
const validateAvailableMenu = (menuHours) => {
  if (menuHours && !menuHours.anyTime) {
    const DAYS_OF_THE_WEEK = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const today = new Date().getDay();
    const index_day = DAYS_OF_THE_WEEK[today];

    const day = menuHours.days && menuHours.days[index_day];
    return day && day.isAvailable ? true : false;
  }
  return true; // If anyTime is true or menuHours is undefined, return true
};

//below for meet pref and flavor match on restaurant page
$(document).ready(function(){

  var MEETS_PREFERENCES = null;
  var MY_FOOD_PREFERENCES = null;
  const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);

  // Menu images carousel UI
  if (!(isMobile || $(window).width() < 480)){ // carousel desktop ui
    $(document).on('mouseover', '.menu-item-images', function(e){
      $(e.currentTarget).find('.desktop-carousel-ui').show();
    });
    $(document).on('mouseleave', '.menu-item-images', function(e){
      $(e.currentTarget).find('.desktop-carousel-ui').hide();
    });
  }
  $(document).on('click', '.mobile-carousel-ui-expander', function(e){
    // $(e.currentTarget).find('.carousel-ui').hide();
    const state = $(e.currentTarget).data('state');
    const itemId = $(e.currentTarget).data('item-id');
    if (state == 'collapsed'){
      $(e.currentTarget).data('state', 'open')
      $(e.currentTarget).removeClass('pi-svg-expander-close')
      $(e.currentTarget).addClass('pi-svg-expander-open')

      $(`.mobile-carousel-ui[data-item-id=${itemId}]`).show();
    } else {
      $(e.currentTarget).data('state', 'collapsed')
      $(e.currentTarget).removeClass('pi-svg-expander-open')
      $(e.currentTarget).addClass('pi-svg-expander-close')

      $(`.mobile-carousel-ui[data-item-id=${itemId}]`).hide();
    }
  });


  $.promisedAjax({
      url: `/my-food-preferences-venue?venueId=${$("#venueId").val()}`,
      method: 'GET',
  }).then(res => { MY_FOOD_PREFERENCES = res.data });

  //$('.select-suitable-dish-all').unbind('click');
 $(document).on('click', '.select-suitable-dish-all', function(){
   var id = $(this).parent().data('itemId');
    select_all_preferences($(this),id,'menu');
  })
 //$('.select-suitable-dish').unbind('click');
  $(document).on('click', '.select-suitable-dish', function() {
  select_preferences($(this)); 
  })
 function select_all_preferences(Elem,nodeKey,type){
  var deitPrefvalue = Elem.data('value')
  let litags = $('.favorite-item #collapse-'+type+'-item-'+nodeKey).find('li');
  let liSelecttags = $('#collapse-'+type+'-item-'+nodeKey).find('li.select-suitable-dish[data-value="'+ deitPrefvalue +'"]').addClass('active');

  let litagsREG = $('.regular-menu #collapse-'+type+'-item-'+nodeKey).find('li');
  let liSelecttagsREG = $('.regular-menu #collapse-'+type+'-item-'+nodeKey).find('li.select-suitable-dish[data-value="'+ deitPrefvalue +'"]').addClass('active');


    let getAllSelect = liSelecttags.parent();
    var selectedVal = [];
    var getval = []
    Object.keys(getAllSelect).map(function(key) {
      Object.keys(getAllSelect[key]).map(function(key2) {
        var numbers = /^[-+]?[0-9]+$/;
        if(key2.match(numbers)){
          if(getAllSelect && getAllSelect[key2]){
          let pushdata = getAllSelect[key2].getAttribute('data-preference');
          selectedVal.push(pushdata);
          }
        }
      });
    });
    litags.removeClass('active');
    liSelecttags.addClass('active');
    litags.css({'background-color': 'white'})

    litagsREG.removeClass('active');
    liSelecttagsREG.addClass('active');
    litagsREG.css({'background-color': 'white'})


    switch(Elem.data('value')) {
    case 'yes':
      liSelecttags.css({'background-color': '#4caf50'})
      liSelecttagsREG.css({'background-color': '#4caf50'})
      Elem.css({'background-color': '#4caf50'})
      break;
    case 'no':
      liSelecttags.css({'background-color': '#ff5722'})
      liSelecttagsREG.css({'background-color': '#ff5722'})
      Elem.css({'background-color': '#ff5722'})
      break;
    case 'canrequest':
      liSelecttags.css({'background-color': '#ffc107'})
      liSelecttagsREG.css({'background-color': '#ffc107'})
      Elem.css({'background-color': '#ffc107'})
      break;
    case 'notsure':
      liSelecttags.css({'background-color': '#9e9e9e'})
      liSelecttagsREG.css({'background-color': '#9e9e9e'})
      Elem.css({'background-color': '#9e9e9e'})
      break;
    case 'mostly':
      liSelecttags.css({'background-color': '#8bc34a'})
      liSelecttagsREG.css({'background-color': '#8bc34a'})
      Elem.css({'background-color': '#8bc34a'})
      break;
    case 'na':
      liSelecttags.css({'background-color': '#9e9e9e'})
      liSelecttagsREG.css({'background-color': '#9e9e9e'})
      Elem.css({'background-color': '#9e9e9e'})
      break;
    default:
      // code block
    }
    let allPrefdata=[];
    selectedVal.forEach(function(pref){
    let infor = {
      item_id: nodeKey,
    preference: pref,
    value: Elem.data('value')
    }
    allPrefdata.push(infor);
    })
    if(!allPrefdata) return false;
     return save_all_my_food_preferences(allPrefdata);
  }


  function save_all_my_food_preferences(infor = {}){
    let data = {
      'infor' : infor,
      'venueId' : $('#venue-id').text().trim()
    }
    $.ajax({
      url: "/my-all-food-preferences/save",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
      success: function (res) {
        toastr.success('Your dietary preference is saved');
        MEETS_PREFERENCES = false;
        let item_id=null;
        if(infor && infor.length>0){
          item_id = infor[0].item_id
        }
        meets_my_food_perferences(item_id); //to update the button value
      },
      error: function (e) {
        return false;
      }
    })
  }

  function select_preferences(Elem){
    let litags = Elem.parent().find('li');
    let litagsval = Elem.data('value');
    let selectAlltag = Elem.parents('.my-food-preferences').find('.select-suitable-dish-all');
    let selectAllUl = Elem.parents('.my-food-preferences').find('.select-suitable-list-all li[data-value='+litagsval+']');
    litags.removeClass('active');
    Elem.addClass('active');
    let selecttag = Elem.parents('.my-food-preferences').find('.select-suitable-list li.active');
    let selecttagcount = selecttag.length;
    let getAllFood = Elem.parents('.my-food-preferences').find('.select-suitable-list');
    let data = [];
    _.forEach(selecttag, (item)=>{
      let selected = $(item).data('value');
       switch($(item).data('value')) {
        case 'yes':
          data.push('yes');
          break;
        case 'no':
        case 'strictly-no':
          data.push('no');
          break;
        case 'canrequest':
          data.push('canrequest');
          break;
        case 'notsure':
          data.push('notsure');
          break;
        case 'mostly':
          data.push('mostly');
          break;
        case 'na':
          data.push('na');
          break;
        default:
          // code block
      }
    });

    let pre_css = {};
      switch(litagsval) {
        case 'yes':
          pre_css = {'background-color': '#4caf50'};
          break;
        case 'no':
          pre_css = {'background-color': '#ff5722'};
          break;
        case 'strictly-no':
          pre_css = {'background-color': '#ef5350'};
          break;
        case 'canrequest':
          pre_css = {'background-color': '#ffc107'};
          break;
        case 'notsure':
          pre_css = {'background-color': '#9e9e9e'};
          break;
        case 'mostly':
          pre_css = {'background-color': '#8bc34a'};
          break;
        case 'na':
          pre_css = {'background-color': '#9e9e9e'};
          break;
        default:
      }
      selectAlltag.removeClass('active');
      litags.css({'background-color': 'white'})
      Elem.css(pre_css);
      var count = data.reduce(function(n, val) {
        return n + (val === litagsval);
      }, 0);
      if(count==getAllFood.length){
        selectAllUl.css(pre_css);
      }else{
        selectAlltag.css({'background-color': 'white'});
      }
    let infor = {
      item_id: Elem.parent().data('item-id'),
      preference: Elem.parent().data('preference'),
      value: Elem.data('value')
    }
    return save_my_food_preferences(infor);
  }

  function save_my_food_preferences(infor = {}){
    let data = {
      venue_id: $('#venue-id').text().trim(),
      item_id: infor.item_id,
      preference: infor.preference,
      value: infor.value
    }
    $.ajax({
      url: "/my-food-preferences/save",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
      success: function (res) {
        toastr.success('Saving ...');
        MEETS_PREFERENCES = false;
        meets_my_food_perferences(infor.item_id); //to update the button value
      },
      error: function (e) {
        return false;
      }
    })
  }

  function meets_my_food_perferences(item_id) {
    if(MEETS_PREFERENCES){
      return fill_color_for_items(item_id);
    };
    var venueId =$("#venueId").val();
    let data = {
      venueId: venueId
    }
    $.ajax({
      url: '/menuitems/findMenuItemsDietPreferences',
      method: 'POST',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
      dataType: 'json',
      error: function (err) {
        return false;
      }
    }).then(function (infor) {
      MEETS_PREFERENCES = infor;
      fill_color_for_items(item_id);
    })
  }
  $(document).on('click', '.meetbtn', function() {
   if(typeof $(this).attr("id") !='undefined'){
    var idval=$(this).attr("id").split("-");
    if(idval.length >=3) idval = idval[4].trim();
    else idval='';
    $('.expert-review-of-'+idval).removeClass("show");
   }
  });
  $(document).on('click', '.flavor-match-btn', function() {
   if(typeof $(this).attr("data-item-id") !='undefined'){
    var idval=$(this).attr("data-item-id");
    if(idval) idval=idval.trim();
    $('.collapse-menu-item-'+idval).removeClass("show");
   }
  });
  function fill_color_for_items(element){
    element = element.trim();
    let show_not_meeting = $('#show-food-not-meet').prop('checked');

//5d0f51ca4495f1125bb6db27: "notsure", 5e6f9007d0cc18356c8ac1d1: "notsure", 5d0f51ca4495f1125bb6db28: "strictly-no", 5d0f51ca4495f1125bb6db29: "na", 5d0f51ca4495f1125bb6db2a: "strictly-no", …}

  // whne new user come

  _.forIn(MEETS_PREFERENCES,(value, key)=>{

      if(key != element) return;
      let elem = $(`#menu-meets-preferences-item-${element},#favorites-meets-preferences-item-${element}`);
      if(elem && elem.attr('class')) {
        let button_class = elem.attr('class').match(/cus-btn-(?!fluid)\S+/g);
        if(button_class) elem.removeClass(button_class.join(' '))
      }
      switch (value){
        case 'yes':
          elem.addClass('cus-btn-green');
          elem.html('<i class="fa fa-heart" aria-hidden="true" style="font-size: inherit;"></i><span style=""> Meets</span>')
          break
        case 'mostly':
            elem.addClass('cus-btn-light-green');
            elem.html('<i class="fa fa-check-circle" aria-hidden="true" style="font-size: inherit;"></i><span style=""> Mostly meets </span>')
            break
        case 'canrequest':
          elem.addClass('cus-btn-amber');
          elem.html('<i class="fa fa-question-circle" aria-hidden="true" style="font-size: inherit;"></i><span style=""> Can Request </span>')
          break
        case 'notsure':
          //elem.addClass('cus-btn-grey');
          elem.html('<i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: inherit;"></i><span style=""> Not sure </span>')
          break
        case 'no':
        case 'strictly-no':
          elem.addClass('cus-btn-red');
          elem.html(`<i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: inherit;"></i><span style=""> Doesn't meet </span>`)
          let regular_elem = $(`#regular_${element}`);
          let recommended_elem = $(`#favorite_${element}`)
          if(show_not_meeting){
            regular_elem.hide()
            recommended_elem.fadeOut('slow','swing')
            recommended_elem.hide()
          }else{
            regular_elem.show()
            recommended_elem.show()
          }
          break
        case 'na':
          //elem.addClass('cus-btn-grey');
          elem.html('<i class="fa fa-exclamation-circle" aria-hidden="true" style="font-size: inherit;"></i><span style=""> May meet</span>')
          break
      }
    })
  }
  $('#show-food-not-meet').on('change', function(){
  let show_not_meeting = $('#show-food-not-meet').prop('checked')
  //if must match my diet pref is checked, then get the user preferences,  else remove them from the selected list
      if (this.checked) {
          let selectedval = $('#dietaryPreferences').val();
          let getuserdata = userdietnames;
          let concatdata = selectedval.concat(getuserdata);
          let uniquedata = $.unique(concatdata);
          let result = Array.from(new Set(uniquedata));
          addUserPrefs(result);
      } else {
        let selectedval = $('#dietaryPreferences').select2("val");
        $('#dietaryPreferences').val(null).trigger('change')
          //hide, show in the tree
        let menuitemList=$(".favorite-item");
        menuitemList.each(function(index,element){
          let itemId = $(element).attr('id');
          $("#"+itemId).removeAttr("hidden");
          $("#"+itemId).show();
        })
        let regularMenu=$(".regular-menu");
        regularMenu.each(function(index,elements){
          let regitemId = $(elements).attr('id');
          $("#"+regitemId).removeAttr("hidden");
          $("#"+regitemId).show();
        })
      }
  })
  function color_code(color){
    switch (color){
      case 'yes':
        return '#4caf50'
      case 'na':
        return '#9e9e9e'
      case 'canrequest':
        return '#ffc107'
      case 'notsure':
        return '#9e9e9e'
      case 'mostly':
        return '#8bc34a'
      case 'no':
        return '#ff5722'
      case 'strictly-no':
        return '#ef5350'

    }
  }
  $("#tree").find('.rating').on('click', function(){
    get_reviews($(this));
  })

  //Collapse Dietary Preferences
  $(document).on("click", `[id^="menu-meets-preferences-item-"], [id^="favorites-meets-preferences-item-"]`, function(e) {
    const itemId = $(e.currentTarget).data('item-id');
    const cardType = $(e.currentTarget).attr('id').includes('favorites') ? 'favorites' : 'menu';

    const itemCard = $(`.menuitem-key-${itemId}`)[0];
    if (itemCard){
      const $itemCard = $(itemCard);

      const menuName = $itemCard.data('menu-name');
      const sectionName = $itemCard.data('section-name');

      const menu = dataTree.find(r => r.title == menuName);
      const section = menu.children.find(r => r.title == sectionName);
      const menuitem = section.children.find(r => r.key == itemId);

      var itemFlavors = menuitem.expertReview || null;
      var itemFlavorsLow =  menuitem.expertReviewLow || null;
      var itemFlavorsHigh = menuitem.expertReviewHigh || null;

      const account = JSON.parse($('#account-infor').text());

      let chooseBoxes = ``;
      if(account && account.dietaryPreferences){
        account.dietaryPreferences.forEach((ele)=> {
          if(ele.name){
            chooseBoxes += `
              <div class="form-group item-preferences mb-0">
                <div class="foodpref-font">Is this dish ${ele.name}?</div>
                  <ul class="select-suitable-list d-flex justify-content-between pl-0 mb-0" data-item-id="${menuitem.key}" data-preference="${ele.name}">
                <li class="select-suitable-dish text-center ${MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'yes' ? 'active' : '' }" data-value="yes" style="background-color: ${ MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'yes' ? '#4caf50' : 'white' }">
                  <a class="text-black" href="javascript:void(0)">Yes</a>
                </li>
                <li class="select-suitable-dish text-center ${['mostly', 'strictly-mostly'].includes(MY_FOOD_PREFERENCES[menuitem.key][ele.name]) ? 'active' : '' }" data-value="mostly" style="background-color: ${ ['mostly', 'strictly-mostly'].includes(MY_FOOD_PREFERENCES[menuitem.key][ele.name]) ? '#8bc34a' : 'white'}">
                  <a class="text-black" href="javascript:void(0)">Mostly</a>
                </li>
                <li class="select-suitable-dish text-center ${MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'canrequest' ? 'active' : '' }" data-value="canrequest" style="background-color: ${ MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'canrequest' ? '#ffc107' : 'white'}">
                  <a class="text-black" href="javascript:void(0)">Can Request</a>
                </li>
                <li class="select-suitable-dish text-center ${MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'notsure' ? 'active' : '' }" data-value="notsure" style="background-color: ${ MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'notsure' ? '#9e9e9e' : 'white'}">
                  <a class="text-black" href="javascript:void(0)">Not Sure</a>
                </li>
                <li class="select-suitable-dish text-center ${['no', 'strictly-no'].includes(MY_FOOD_PREFERENCES[menuitem.key][ele.name]) ? 'active' : '' }" data-value="no" style="background-color: ${ ['no', 'strictly-no'].includes(MY_FOOD_PREFERENCES[menuitem.key][ele.name]) ? '#ff5722' : 'white'}">
                  <a class="text-black" href="javascript:void(0)">No</a>
                </li>
                <li class="select-suitable-dish text-center ${MY_FOOD_PREFERENCES[menuitem.key][ele.name] == 'na' ? 'active' : '' }" data-value="na" style="background-color: ${ MY_FOOD_PREFERENCES[menuitem.key][ele.name] ==  'na' ? '#9e9e9e' : 'white'}">
                  <a class="text-black" href="javascript:void(0)">N/A</a>
                </li>
                </ul>
              </div>
            `
          }
        })
      }

      let html = `
        <div class="form-group mb-0 item-preferences all-dietary-preferences">
          <div class="foodpref-font">Set all Dietary Preferences to</div>
          <ul class="select-suitable-list-all d-flex justify-content-between pl-0 mb-0" data-item-id="${menuitem.key}" data-preference="">
            <li class="select-suitable-dish-all text-center" data-value="yes" style="background-color: 'white';">
              <a class="text-black" href="javascript:void(0)">Yes</a>
            </li>
            <li class="select-suitable-dish-all text-center" data-value="mostly" style="background-color: 'white';">
              <a class="text-black" href="javascript:void(0)">Mostly</a>
            </li>
            <li class="select-suitable-dish-all text-center" data-value="canrequest" style="background-color: 'white';">
              <a class="text-black" href="javascript:void(0)">Can Request</a>
            </li>
            <li class="select-suitable-dish-all text-center" data-value="notsure" style="background-color: 'white';">
              <a class="text-black" href="javascript:void(0)">Not Sure</a>
            </li>
            <li class="select-suitable-dish-all text-center" data-value="no" style="background-color: 'white';">
              <a class="text-black" href="javascript:void(0)">No</a>
            </li>
            <li class="select-suitable-dish-all text-center" data-value="na" style="background-color:'white';">
              <a class="text-black" href="javascript:void(0)">N/A</a>
            </li>
          </ul>
        </div>

        ${chooseBoxes}
      `;

      $(`#collapse-menu-item-${itemId}`).html(html);
    }
  });

  $(document).on("click", `.flavor-match-btn`, function(e) {
    const screenWidth = $(document).width();
    const itemId = $(e.currentTarget).data('item-id');
    const cardType = $(e.currentTarget).data('target').includes('favorites') ? 'favorites' : 'menu';

    const itemCard = $(`.menuitem-key-${itemId}`)[0];
    if (itemCard){
      const $itemCard = $(itemCard);

      const menuName = $itemCard.data('menu-name');
      const sectionName = $itemCard.data('section-name');

      const menu = dataTree.find(r => r.title == menuName);
      const section = menu.children.find(r => r.title == sectionName);
      const menuitem = section.children.find(r => r.key == itemId);

      var itemFlavors = menuitem.expertReview || null;
      var itemFlavorsLow =  menuitem.expertReviewLow || null;
      var itemFlavorsHigh = menuitem.expertReviewHigh || null;

      let sliders = ``;
      for (var key in itemFlavors) {
        if (itemFlavors.hasOwnProperty != undefined && itemFlavors.hasOwnProperty) {
          var keyValue = key;
          if (keyValue == 'savory') {
            keyValue = 'Umami (meaty taste)';
          } else if (keyValue == 'valueForPrice') {
            keyValue = "What it's worth";
          }
          sliders += `
            <div class="col-md-6 col-12">
              <div class="row flavor-title">
                <div class="col-12 text-center font-bold">
                  ${keyValue}
                </div>
              </div>
              <div class="row flavor-slider ">
                <div class="col-12">
                  <input type="text" class="range-slider-flavor flat-slider" data-provide="slider" data-slider-value="[${itemFlavorsLow[key]},${itemFlavorsHigh[key]}]"
                    data-slider-selectedval="${itemFlavors[key]}" />
                </div>
              </div>
              <div class="form-row d-flex justify-content-between px-md-1 px-3">
                <div>Low</div>
                <div>High</div>
              </div>
            </div>
          `
        }
      }

      let html = `
        <div class="expertReviewDetail">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-row form-group d-flex justify-content-between">
                <div><i class="fa fa-circle" aria-hidden="true" style="color: orange"></i> Dish Score</div>
                <div><i class="fa fa-circle" aria-hidden="true" style="color: green"></i> My preferences</div>
              </div>
            </div>
          </div>
          <div class="row">
            ${sliders}
          </div>
        </div>
      `;

      $(`#expert-review-of-${itemId}`).html(html);
      $(`#expert-review-of-${itemId} .flat-slider`).bootstrapSlider({
        min: 0,
        max: 100,
        tooltip: 'false',
        values: [40, 60],
        formatter: function (value) {
          return;
        },
        disable: true,
        disabled: true,
      });
    }
  });
});
//get_all_flavor_match();

/* new design code from here */

function upload_menu_item_images(data){
  if(!_.size(data)) return false;
  let html = '';
  _.forEach(data.images,(item)=>{
      html += `
          <div class="carousel-item  text-center active">
            <img loading="lazy" class="carousel-image img-thumbnail menu-item-image" src="${item.url}"  alt="Item Image">
          </div>
      `;
  });
  let elem = $(`.carousel-menu-item-${data.itemId}`).find('.carousel-inner')
  elem.prepend($(html))
  elem.find('.carousel-inner').removeClass('active');
  elem.find('.carousel-inner').first().addClass('active');
  return toastr.success('Upload images successfully')
}
//
function set_default_item_image(data){
  return $.ajax({
      url: '/set-default-menu-item-images',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
      success: function (res) {
        return toastr.success('Set image as default successfully')
      }
  })
}
//
function delete_item_image(data){
  return $.ajax({
      url: '/delete-menu-item-images',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
      success: function (res) {
        if(!_.size(data)) return false;
        _.remove(ITEM_PHOTOS[data.item_id], img => img.url == data.image)
        let elems = $(`#carousel-menu-item-${data.item_id}`)
        let photos = elems.find('.carousel-item')
        if(_.size(photos) == 1){
          let default_photo = `<img class="img-thumbnail" src="/images/tempfoodnotext.png" style="height: 200px" class="img-thumbnail" alt="Item Image">`
          elems.parent().append($(default_photo))
          elems.remove()
          return true
        }
        $.each(photos, function(index, el){
          if($(el).find('img').attr('src') == data.image) {
            $(`#carousel-menu-item-${data.item_id}`).carousel('next')
            setTimeout(()=>{$(el).remove()}, 1000)
            return false
          }
        })
        return toastr.success('Remove image successfully')
      }
    })
}
// -------------------------------------------------------------------
var ITEM_PHOTOS = '';
var item_images = false;

/* being used to get menuitems images */
window.get_item_images = function() {
  if(item_images !== false ) return true;
  item_images = true;
  let venueId = $("#venueId").val();
  let data = {
    venueId: venueId
  }
   $.ajax({
    url: "/menus/images",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(data),
    success: function (res) {
      ITEM_PHOTOS = res.data
      render_item_images();
    },
    error: function (e) {
      return false;
    }
  })
}

$(document).ready(function(){
       setTimeout(()=>{
         get_item_images()
         }, 400)
});

function render_item_images(item_id = null) {
  if (!_.size(ITEM_PHOTOS)) return '';
  let list_items = ITEM_PHOTOS

  function render_images_slider(images, item_id, unique_key) {
    let html = '';
    images.forEach((img, ind) => {
      html += `
          <div class="carousel-item  text-center ${ind == 0 ? 'active' : ''}">
            <div class="image-container aspect-ratio-box" data-unique-key="${unique_key}">
              <div class="aspect-ratio-box-inside">
                <img loading="lazy" class="carousel-image menu-item-image img-aspect-ratio img-intersection" data-item-id="${item_id}" src="${img.url}" style="min-height:100%; width: 100% ;object-fit: cover" alt="Item Image" loading="lazy" >
            </div>
            </div>
          </div>
        `
    })
    return html;
  }
  function create_carousel(item, key) {
    let indicatorHTML = ``;
    if (isMobile || $(window).width() < 480){
      window.attachCarouselIndicators('[id^="carousel-menu-item-"]'); // menu item image carousel
      for (var i = 0; i < item.length; i++) {
        indicatorHTML += `<span class="${window.getIndicatorClass(i, 0, 0, 3, item.length)}"></span>`
      }
    }

    let unique_key = Math.random().toString(36).substring(2)
    let html = `
      <div id="carousel-menu-item-${key}" class="images-of-menu-item carousel slide carousel-${unique_key}" data-item-id="${key}"  data-interval="false" style="${window.innerWidth > 480 ? '' : 'width: 90%'}">
          <div class="indicators-wrapper" data-min=0 data-max=3 data-max-visible=3>
            ${indicatorHTML}
          </div>
          <div class="carousel-inner order-this-item" data-item-id="${key}">
            ${render_images_slider(item, key, unique_key)}
          </div>
          <div class="desktop-carousel-ui">
          <a class="carousel-control-prev ${item && item.length > 1 ? '' : 'hide'} " href=".carousel-${unique_key}" data-slide="prev" role="button">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next ${item && item.length > 1 ? '' : 'hide'} " href=".carousel-${unique_key}" data-slide="next" role="button">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
          </div>
      </div>
    `;
    return html
  }
  function render_images_slider_zoom(elem) {
    let html = '';
    elem.each(function (ind, item) {
      let imageUrl = $(item).find('img').attr('src');
      html += `
            <div class="carousel-item  text-center ${$(item).hasClass('active') ? 'active' : ''}">
                <img class="carousel-image" src="${imageUrl}" style="width: 100%;" alt="Item Image">
            </div>`;
    })
    return html;
  }
  _.forIn(list_items, (item, key) => {
    if (!_.size(item)) return true
    let elements = $('.images-for-item-' + key).find('.list-image-item');
    if (!_.size(elements)) return true
    $.each(elements, function (index, elem) {
      let html = create_carousel(item, key)
      $(elem).html(html);
      $(elem).find('.order-this-item').unbind('click').on('click', function (e) {
        $(".shopping_card").removeClass("animated bounce")
        $(".shopping_cart_btn .scard").removeClass("animated bounce")
        e.stopPropagation();
        let id = $(this).attr('data-item-id');
        let nodesub = $("#menuitemData_" + id);
        if (nodesub) {
          nodesub = nodesub.val();
          showItemModal(nodesub);
        } else {
          console.log("order-this-item menuitemData_ not found for ...", id);
        }
      });
      $(`#carousel-menu-item-${key}`).carousel()
    })
  });
 /*$(body).on("click",".order-this-item",function(e) {
 console.log("click model");
    $(".shopping_card").removeClass("animated bounce")
    $(".shopping_cart_btn .scard").removeClass("animated bounce")
    e.stopPropagation();
    let id = $(this).attr('data-item-id');
    let nodesub = $("#menuitemData_" + id);
    if (nodesub) {
      nodesub = nodesub.val();
      showItemModal(nodesub);
    } else {
      console.log("order-this-item menuitemData_ not found for ...", id);
    }
  });
*/

  change_zoom_cursor('#imageCarousel')
  $('#imageCarousel, .slider-menus').find('.carousel-inner').on('click', function () {
    let parentElem = $(this).parent();
    let itemId = parentElem.data('item-id');
    let showBtn = '';
    if (itemId && itemId != undefined) {
      showBtn = `<button type="button" id="item_add_to_card" class="btn" data-item-id="${itemId}" style="background-color: #02843d;">See More</button>`;
    } else {
      showBtn = `<a href="javascript:void(0);" type="button" id="see_restaurant_menu" class="btn">See Menu</a>`;
    }
    let elem = $(this).children();
    let html = `
         <div id="modal-restaurant-images" class="modal" role="dialog" >
              <div class="modal-dialog" style="max-width:750px; top: 5%">
                <div id="carousel-menu-item" class="images-of-menu-item carousel slide" data-ride="carousel" data-interval="false" style="${window.innerWidth > 480 ? '' : 'width: 100%'}">
                  <div style=" position: absolute; top: 2%; right: 2%; z-index: 999;">
                    <button type="button" class="close btn" data-dismiss="modal" style="">×</button>
                  </div>
                  <div class="carousel-inner">
                    ${render_images_slider_zoom(elem)}
                  </div>
                  <a class="carousel-control-prev" href="#carousel-menu-item" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carousel-menu-item" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
                <div class="text-center mt-1">
                    ${showBtn}
                </div>
              </div>
          </div>
      `;
    $(".show-modal-restaurant-slider").html(html);
    $("#modal-restaurant-images").modal('show');
    $("#modal-restaurant-images").css(
      "backdrop-filter", "blur(75px)",
      "background-color", "#01223770",
    )
  })

  $('.zoom-menu-item-photo').unbind('click').on('click', function () {
    let key = $(this).data('key')
    let itemId = $(this).data('item-id');
    let indicatorHTML = ``;
    let elem = $(`.list-image-item[data-key="${key}"]`).find('.carousel-inner').children()
    if (isMobile || $(window).width() < 480){
      window.attachCarouselIndicators(`[id^='carousel-menu-item']`); // menu item image carousel
      for (var i = 0; i < elem.length; i++) {
        indicatorHTML += `<span class="${window.getIndicatorClass(i, 0, 0, 3, elem.length)}"></span>`
      }
    }
    let showBtn = '';
    if (itemId && itemId != undefined) {
      showBtn = `<button type="button" id="item_add_to_card" class="btn" data-item-id="${itemId}" style="background-color: #02843d;">See More</button>`;
    } else {
      showBtn = `<a href="javascript:void(0);" type="button" id="see_restaurant_menu" class="btn">See Menu</a>`;
    }
    let html = `
         <div id="modal-restaurant-images" class="modal" role="dialog" >
              <div class="modal-dialog" style="max-width:750px; top: 5%">
                <div id="carousel-menu-item" class="images-of-menu-item carousel slide" data-ride="carousel" data-interval="false" style="${window.innerWidth > 480 ? '' : 'width: 100%'}">
                <div class="indicators-wrapper" data-min=0 data-max=3 data-max-visible=3>
                ${indicatorHTML}
              </div>
                  <div style=" position: absolute; top: 2%; right: 2%; z-index: 999;">
                    <button type="button" class="close btn" data-dismiss="modal" style="">×</button>
                  </div>
                  <div class="carousel-inner">
                    ${render_images_slider_zoom(elem)}
                  </div>
                  <a class="carousel-control-prev" style="position: absolute;bottom: 0 !important;" href="#carousel-menu-item" role="button" data-slide="prev" role="button">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" style="position: absolute;bottom: 0 !important;" href="#carousel-menu-item" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
                <div class="text-center mt-1">
                    ${showBtn}
                </div>
              </div>
          </div>
      `;
    $(".show-modal-restaurant-slider").html(html);
    $("#modal-restaurant-images").modal('show');
    $("#modal-restaurant-images").css(
      "backdrop-filter", "blur(75px)",
      "background-color", "#01223770",
    )

  })
}


function change_zoom_cursor (elem){
  let img_link = $(elem).find('.item.active').find('img').attr('src');
  let cursor_icon, cursor_color;
  if(_.includes(img_link,'/images/')){
      cursor_icon = '\uf093';
      cursor_color = 'green'
  }else{
      cursor_icon = '\uf00e';
      cursor_color = '#FFCC00'
  }
  let canvas = document.createElement("canvas");
  canvas.width = 24;
  canvas.height = 24;
  //document.body.appendChild(canvas);
  let ctx = canvas.getContext("2d");
  ctx.fillStyle = cursor_color;
  ctx.font = "24px FontAwesome";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(cursor_icon, 12, 12);
  let dataURL = canvas.toDataURL('image/png')
  $(elem).css('cursor', 'url('+dataURL+'), auto');
}

// ----------------------------------------------------------------------------------------



  function showItemModal(node){
    if(CHECK_SHOW_MODAL_ORDER){
      return ;
    }
    CHECK_SHOW_MODAL_ORDER = true;
    if(typeof node === "undefined"){
      console.log("error in showingitemmodal for undefined node");
    } else {
      try{
        node=JSON.parse(node);
      }catch(err){
        console.log("error in showingitemmodal parsing node...", node);
      }
        const itemId = node['key'];
        saveSelection(itemId);
       modal_render_item_ordered(itemId);
      $('#modal-order-item-addons').on('shown.bs.modal', function (e) {
        CHECK_SHOW_MODAL_ORDER = false;
      });
    }
  }
  window.__showItemModal = showItemModal;
$(document).on("change","#price_search_rest",function(e) {

  var priceVal = $('#price_search_rest').val();
  let arr = priceVal.split(',');

  if(arr[0]==100){
    $(" #priceRange_header .min-slider-handle").html("<p  style='position: absolute;top: 20px;width: 60px;' class='low'>$ " +arr[0] + '</p>');
  }
  else{
    $("#priceRange_header .min-slider-handle").html("<p style='position: absolute;top: 20px;width: 60px;' class='low'>$ " +arr[0] + '</p>');
  }
  if(arr[1]==100){
    $("#priceRange_header .max-slider-handle").html("<p style='position: absolute;top: 20px;width: 60px;' class='low'>$ " +arr[1] + '</p>');
  }
  else{
    $("#priceRange_header .max-slider-handle").html("<p style='position: absolute;top: 20px;width: 60px;' class='low'>$ " +arr[1] + '</p>');
  }
});

$(document).on("click","#item_add_to_card",function(e) {
    e.stopPropagation();
    var idval= e.target.id;
    let id = $(this).attr('data-item-id');
    let nodesub = $("#menuitemData_"+id);
    if(nodesub){
      nodesub = nodesub.val();
      $("#modal-restaurant-images").modal('hide');
      showItemModal(nodesub);
    } else {
      console.log("item_add_to_card menuitemData_ not found for ...",id);
    }
})

$(document).on("click","#see_restaurant_menu",function(e) {
  $(document).scrollTop( $("#favorites-menu").offset().top - 100 );
  $("#modal-restaurant-images").modal('hide');
})
$(document).ready(function(){
/*  getting rating data from controller in loadRestaurant call
  let menuitemData=$(".menuitemData");
  $(".menuitemData").each(function(index,element){
//  JSON.parse(menuitemData).forEach((item) => {
     let item=$(this).val();
    if(item){
      item=JSON.parse(item);
       $("#ratings-"+item.key).html(getRatingHTML(item.rating,item.reviews,5,false,item.key,item.rating,item.reviews,item.upc,item.sku));
       $("#meetprefdiv-"+item.key).html(render_meets_preferences_button(item.key, item.meets_preferences, `#collapse-favorites-item-${item.key}`))
    }
  });
  */


window.$amazon.callback['item_images'] = function(){
  let venueId = $('#venueId').val();
  let data = {
      venueId: venueId,
      itemId: window.$amazon.data.item_id,
      images: window.$amazon.urls
  }
  $.ajax({
      url: '/upload-menu-item-images',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
      success: function (res) {
        let photos = {
            item_id: data.itemId,
            url: data.images[0],
            updated: new Date()
          }
        if(ITEM_PHOTOS[data.itemId]) ITEM_PHOTOS[data.itemId].push(photos)
        else ITEM_PHOTOS[data.itemId] = [photos]
        return render_item_images(data.itemId)
      }
    })
};
    $('.order-this-item').unbind('click').on('click', function(e){
      $(".shopping_card").removeClass("animated bounce")
      $(".shopping_cart_btn .scard ").removeClass("animated bounce")
      var keyid=$(this).attr('data-item-id')
      e.stopPropagation();
      var idval= e.target.id;
        let id = $(this).attr('data-item-id');
           let nodesub = $("#menuitemData_"+id);
           if(nodesub){
            nodesub = nodesub.val();
            let node = JSON.parse(nodesub);
             if (node.children && node.children.length > 0 && node.children.max != 1) {
               if ( node.children[0] && node.children[0].children && node.children[0].children.length > 0) {
                 node.children[0].children.map(item => {
                   if (item.max == 1) {
                     if (item && item.selectedByDefault && item.selectedByDefault == "yes") {
                       setTimeout(() => {
                         $(`#modal-node-${item.key}`).trigger('click');
                         $("#modal-node-" + item.key).prop("checked", true);
                       }, 1000)
                     }
                   }
                 })
               }
             }
            showItemModal(nodesub);
          } else {
            console.log("order-this-item menuitemData_ not found for ...",id);
          }
     });

   $('.upload-item-images').unbind('click').on('click', function(e) {
    e.preventDefault();
    window.$amazon.type = 'item_images';
    window.$amazon.data['item_id'] = $(this).data('item-id');
    $(window.$amazon.input).click();
  })

  // $('.more_des').unbind('click').on('click', function(e){
  //   let content = $(this).data('content');
  //   let title = $(this).data('title');
  //   $('body').append(`<div class="show-modal-description"></div>`);
  //   let html = `
  //       <div id="modal-description-item" class="modal fade" role="dialog">
  //           <div class="modal-dialog">

  //               <!-- Modal content-->
  //               <div class="modal-content">
  //                   <div class="modal-header">
  //                       <h2 class="modal-title">${title}</h2>
  //                   </div>
  //                   <div class="modal-body">
  //                       ${content}
  //                   </div>
  //                   <div class="modal-footer">
  //                       <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
  //                   </div>
  //               </div>

  //           </div>
  //       </div>
  //   `;
  //   $('.show-modal-description').html(html);
  //   $('#modal-description-item').modal('show');
  // })
$('.set-default-image').unbind('click').on('click', function(e) {
  e.preventDefault();
  let item_id = $(this).data('item-id')
  let image = $(`.images-for-item-${item_id}`).find('.carousel-inner').find('.active').find('img').attr('src')
  if(!image) return toastr.warning('Can not set this image as default')
  let data = {
    venue_id: $('#venueId').val(),
    item_id: item_id,
    image: image
  }
  return set_default_item_image(data)
})

$('.delete-item-image').unbind('click').on('click', function(e) {
  e.preventDefault();
  let item_id = $(this).data('item-id')
  let image = $(`.images-for-item-${item_id}`).find('.carousel-inner').find('.active').find('img').attr('src')
  if(!image) return toastr.warning('Can not remove the default image')
  let data = {
    venue_id: $('#venueId').val(),
    item_id: item_id,
    image: image
  }
  return delete_item_image(data)
})
})
var getRating = function(x, nodetree){
  let rating = 0;
  let ratingx= 0;
  //console.log('rating x=',x,$(x),nodetree);
   ratingx = Number(x.myRating); //this for regular when sorted manually
   if(ratingx>0){
    rating = ratingx
  }
  //console.log("rating..",rating);
  return rating * 20; //to make it out of 100
}
var getRatingHTML = function (itemRating, reviews, maxRating = 5,myrate, idval , rating , review, upc, sku, isFlavorRating=false) {
 //console.log("expertReview+++++++++",JSON.parse(expertReview))
  if(itemRating>0){
    const dataUpdate = {
        venue_id: $('#venueId').val(),
        menuItemId: idval,
        isFlavorRating: isFlavorRating,
        itemRating: itemRating
      }
    // $.ajax({
    //     url: "/updateItemsDiscounts",
    //     type: "POST",
    //     contentType: "application/json; charset=utf-8",
    //     data: JSON.stringify(dataUpdate),
    //     success: function (res) {
    //       console.log("res",idval)
    //     }
    // });
  }
  let mainDiv = $(`<div id="mainRatingDiv-${idval}"></div>`);
  let $html;
  let $html1;
     $html = $(`<div id="${myrate == true ? idval : ''}" data-myRate="${myrate}" class='highest-rated-items-ratebox colorgreen form-inline' style='position: relative; display:${myrate == true ? 'flex' : 'none'}' data-rating=${rating} data-reviews=${review} data-upc='${upc}' data-sku='${sku}'></div>`);

     $html1 = $(`<div class='highest-rated-items-ratebox colorOrange form-inline' style='position: relative; ${myrate == true ? 'display: none' : ''}'  ></div>`);
  if (itemRating > maxRating) {
    itemRating = maxRating;
  }
  if (itemRating && itemRating > 0){
    $html.append(loadRate(itemRating, maxRating, myrate));
  }
   if(rating && rating > 0){
     $html1.append(loadRate(rating, maxRating ,myrate));
   }
   if(review > 0){
    $html1.append(`<span class="total_review_item" style="display:inline !important;font-size: 12px;">${review} <img src="/images/verifiedBadge.svg"></span>`)
    $html.append(`<span class="total_review_item" style="display:inline !important;font-size: 12px;">${review} <img src="/images/verifiedBadge.svg"></span>`)

   }
  //console.log("mainDiv[0]====",mainDiv[0])
  mainDiv.append($html);
  mainDiv.append($html1);
  return mainDiv[0];
};
let rateid = 0;
function loadRate(itemRating, maxRating, myrate=false) {
  if(itemRating > 5) itemRating = 5
  let ratehtml = document.createElement('div');
  ratehtml.innerHTML = "<div class='rate-heart-plate' data-id=" + rateid + " data-rating=" + itemRating + "></div>";
  $(ratehtml.children).rateYo({
    rating: itemRating,
    starWidth: "20px",
    spacing: "3px",
    ratedFill: "green",
    normalFill: "#bdbcbc",
    starSvg: myrate ? __platerate_icons.my_heart_plate : __platerate_icons.heart_plate
  });
  rateid = rateid + 1;
  return ratehtml.innerHTML;
}


function getSortFields(){
  const selected = $('.multi-factor-sorting').find('input[type=checkbox]');
  let sortBy = [];
  if (selected.length > 0){
    for(let i = 0; i < selected.length; i++){
      if($(selected[i]).is(":checked")) {
        let sf = $(selected[i]).attr('data-sort');
        if(sortBy.indexOf(sf)==-1){
          sortBy.push(sf);
        }
      } else {
        console.log("this is not checked...", $(selected[i]).attr('id'));
      }
    }
//  redesign  sortBy.push('meetpre');
  }
  //if both price and highestprice exist, remove both
  if(sortBy.indexOf("price")>=0 && sortBy.indexOf("highestprice")>=0){
    sortBy = sortBy.filter(i => i!== "price" && i!== "highestprice");
  }
  return sortBy;
}

var MENU_TABS = {};
var SUB_MENU_TABS = {}
// ************************************************************************
// DOCUMENT READY----------------------------------------------------------
// ************************************************************************
$(document).ready(function(){


function render_favorite_item_selection(){
  $('#menu-search').val('')
  let menuList = $('.favorite-item');
  let optionList = [];
  let optionHTML = '';
  $.each(menuList, function( index, item ) {
      let menu_name = $(item).data('menu-name');
      if(!_.includes(optionList, menu_name)){
        optionList.push(menu_name);
        optionHTML += `<option value="${menu_name}">${menu_name}</option>`
      }
  });
  $('#menu-selection').html(optionHTML);
  $('#menu-selection').select2({
    placeholder: "Select menu",
    allowClear: true
  });
}
//to extract the items with ratings from dataTree
function favorites_menu(data){

  let list_favorites_menu = [];
  function filter_rating(infor){
    _.forEach(infor, (item)=>{
      if(infor.type == 'item'){
        if(infor.rating > 0) list_favorites_menu.push(infor.key)
        return true
      }
      if(_.size(infor.children)) return filter_rating(infor.children);
      return true;
    })
  }
  filter_rating(data);
  return list_favorites_menu;
}


function render_menu_tabs(data){
  if(!_.size(data)) return false;
  $('#m-menu-tabs').html('');
  MENU_TABS = {
    element: '#m-menu-tabs',
    key: Math.random().toString(36).substring(2),
/* redesign    style: {'border-top': '3px solid green',
      'border-bottom': '1px solid green'
    }, */
    tabs: null
  }
  let tabs = [];
  _.forEach(data,(item, index)=>{
    let tab = {
      title: item.menuName,
      key: index,
      func: () => {return navigate_tabs("menuname_"+index) },
      menu_setting: item
    }
    tabs.push(tab);
  })
  MENU_TABS.tabs = tabs;
  tabs_menu_time()
  // __navigation(MENU_TABS, true);
  return render_list_menu(MENU_TABS)
}

function render_list_menu(data){
  let menu_setting
  try{
    menu_setting = JSON.parse($('#menu-time-setting').val())
  }catch (err) {
    console.log('render_list_menu parsing err')
    console.log(err)
    return false
  }
  let is_restaurant_admin = $('#is-restaurant-admin').val() == 'true'
  let is_saleperson       = $('#is-saleperson').val() == 'true'

  let html = ``
  _.forEach(data.tabs, (item, index) =>{
    try{
    let hasAdmin = false;
    if(userIsLoggedIn && userId) hasAdmin = item.menu_setting.admin.userAdmin;
    let orderType = item.menu_setting.orderType || [];
    let menuHours = item.menu_setting.hours;
    let hasTimeOrder = validateHoursMenus(menuHours);
    let isAvailable = validateAvailableMenu(menuHours);
    let collapse_key = Math.random().toString(36).substring(2)
    html += `
        <div class="card" style="border: none">
          <div class="card-header" id="time-setting-${index}" style="border: none; background-color: white;">
              <div class="d-flex justify-content-between">
                  <div class="mr-3 form-inline rest-dropdown-text" style="font-size: 18px; cursor: pointer;" data-toggle="collapse" data-target="#collapse-${collapse_key}" aria-expanded="true" aria-controls="collapse-${collapse_key}">
                    <div class="mr-2"><i class="far fa-calendar-alt mr-2"></i><b>${item.title}</b></div> | <div class="ml-2">${item.sub_title}</div>
                  </div>
                  <div>
                      <div class="d-flex" data-menu-name='${item.menu_setting.menuName}' data-hours-infor="${item.menu_setting._id}">
                          <div class="text-center mr-3 ${hasAdmin ? 'select-order-type': ''} ${(orderType.includes('order-ahead')) ? 'active' : ''}" data-type="order-ahead" data-hours="${hasTimeOrder}">
                              <a href="javascript:void(0)">
                                  <i class="fa fa-utensils" aria-hidden="true" style="color: ${(orderType.includes('order-ahead')) ? 'green' : 'grey'}; font-size:20px"></i>
                              </a>
                          </div>
                          <div class="text-center mr-3 ${hasAdmin ? 'select-order-type': ''} ${(orderType.includes('pickup')) ? 'active' : ''}" data-type="pickup" data-hours="${hasTimeOrder}">
                              <a href="javascript:void(0)">
                                  <i class="fa fa-store" aria-hidden="true" style="color: ${(orderType.includes('pickup')) ? 'green' : 'grey'}; font-size:20px"></i>
                              </a>
                          </div>
                          <div class="text-center mr-3 ${hasAdmin ? 'select-order-type': ''} ${(orderType.includes('delivery')) ? 'active' : ''}" data-type="delivery" data-hours="${hasTimeOrder}">
                              <a href="javascript:void(0)">
                                  <i class="fa fa-truck" aria-hidden="true" style="color: ${(orderType.includes('delivery')) ? 'green' : 'grey'}; font-size:20px"></i>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          ${is_restaurant_admin || is_saleperson ?
            `<div id="collapse-${collapse_key}" class="collapse" aria-labelledby="time-setting-${index}" data-parent="#accordion-menu-time">
                <div class="card-body">
                    ${renderMenuHours(item.menu_setting)}
                </div>
            </div>`
            : ''
          }
          <div style="border-bottom: 1px lightgrey solid;"></div>
      </div>
    `
    }catch(errr){
      console.log(errr)
    }
  })
  let collapse_key = Math.random().toString(36).substring(2)
  html = `
    <div class="p-2" style="background-color: whitesmoke; border-radius: 5px; border: 2px lightgrey solid; box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);">
      <div class="accordion rest-available-now" id="accordion-menu-time">
          ${html}
          <div class="card" style="border: none; overflow: unset;">
            <div class="card-header" style="border: none; background-color: white;">
              <div data-toggle="collapse" data-target="#collapse-${collapse_key}" aria-expanded="true" aria-controls="collapse-${collapse_key}" style="font-size: 18px; color: green; cursor: pointer;">
                <i class="far fa-clock mr-2"></i>See menu at a specific time
              </div>
            </div>
            <div id="collapse-${collapse_key}" class="collapse" aria-labelledby="" data-parent="#accordion-menu-time">
                <div class="card-body">
                  <span style="font-size: 15px; color: grey">Choose time</span>
                  <div class="d-flex justify-content-between  form-group">
                    <input type="text" id="show-menu-at-specific-time" class="form-control mr-1" placeholder="MM/DD/YYYY" name="show-menu-at-specific-time" style="font-size: 16px; font-weight: bold;">
                    <button class="btn btn-outline-success btn-sm" id="show-menu-item-now">Now</button>
                  </div>
                  <button class="btn btn-success btn-block" id="btn-show-menu-by-time">Show menu items</button>
                </div>
            </div>
          </div>
      </div>
    </div>
  `
  $('#m-menu-tabs').html(html)
  $('#show-menu-at-specific-time').datetimepicker({
    format:  'MM/DD/YYYY LT',
    showClose: true,
    icons: {
      close: 'OK'
    },
    defaultDate: moment(),
  }).on('dp.hide', function(e){
    let selected_date = $('#show-menu-at-specific-time').val().trim()
    selected_date = moment(selected_date, 'MM/DD/YYYY hh:mm A').format('MM/DD/YYYY hh:mma')
    if(selected_date == moment().format('MM/DD/YYYY hh:mma')){
      $('.availablenowbutton').html('Available Now')
      $('.menu-at-time').text('now')
    } else {
      $('.availablenowbutton').html(`As of ${screen.width < 576 ? '' : '<br>'}${moment(selected_date, 'MM/DD/YYYY hh:mma').format('hh:mma MM/DD')}`)
      $('.menu-at-time').text(`on ${selected_date}`)
    }
    setSettingMenu({at_specific_time: selected_date})
    $('#btn-menu-time-setting').trigger('click')
  });
  //ok button 
  $("#show-menu-at-specific-time").on("dp.show", function(e) {
    $('.OK').html("OK").css("background-color","darkgrey");
  });
  $('#show-menu-item-now').on('click', function(){
    let time_now = moment().format('MM/DD/YYYY hh:mm A')
    $('#show-menu-at-specific-time').val(time_now)
    $('#btn-show-menu-by-time').trigger('click')
  })
  $('#btn-show-menu-by-time').on('click', function(){
    let selected_date = $('#show-menu-at-specific-time').val().trim()
    selected_date = moment(selected_date, 'MM/DD/YYYY hh:mm A').format('MM/DD/YYYY hh:mma')
    if(selected_date == moment().format('MM/DD/YYYY hh:mma')){
      $('.availablenowbutton').html('Available Now')
      $('.menu-at-time').text('now')
    } else {
      $('.availablenowbutton').html(`As of ${screen.width < 576 ? '' : '<br>'}${moment(selected_date, 'MM/DD/YYYY hh:mma').format('hh:mma MM/DD')}`)
      $('.menu-at-time').text(`on ${selected_date}`)
    }
    setSettingMenu({at_specific_time: selected_date})
    $('#btn-menu-time-setting').trigger('click')
  })

  init_menu_setting_elevation()
  if(is_restaurant_admin || is_saleperson) update_order_setting()
}
function closeOnClickOutSide() {
  if(!$('#backGroundPopup').length){
    $("body").append('<div id ="backGroundPopup"></div>');
    $("#backGroundPopup").on("click", function() {
      $("#btn-menu-time-setting").data('status', 'hidden')
      $('#popper-menu-time').find('#m-menu-tabs').hide();
      $("#btn-menu-time-setting").find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
      $("#btn-menu-time-setting").css({'box-shadow': ''});
      $("#backGroundPopup").remove();
    })
  }
  
};

function init_menu_setting_elevation(){
  $('#btn-menu-time-setting').unbind('click').on('click', function(){
    closeOnClickOutSide();
    if($(this).data('status') == 'hidden') {
        $(this).data('status', 'show')
        $('#popper-menu-time').find('#m-menu-tabs').show()
        $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-up')
        $(this).css({'box-shadow': '0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)'})
    } else {
      $(this).data('status', 'hidden')
      $('#popper-menu-time').find('#m-menu-tabs').hide()
      $(this).find('i').removeClass('fa-angle-up').addClass('fa-angle-down')
      $(this).css({'box-shadow': ''})
    }
  })
}

function update_order_setting(){
  $('.select-order-type').unbind('click').on('click', function(){
    $(this).toggleClass('active');
    const menuName = $(this).parent().data('menu-name');
    const $selecttype = $(this).parent().find('.active');

    let orderType = []
    if ($selecttype.length > 0){
      for(let i = 0; i < $selecttype.length; i++){
        orderType.push($($selecttype[i]).attr('data-type'));
      }
    }
    if(venueId && menuName) {
      let hourInfor = $(this).parent().data('hours-infor');
      hourInfor = $(`#${hourInfor}`).text();
      try {
        hourInfor = JSON.parse(hourInfor);
      } catch (error) {
        hourInfor = {
          anyTime: true,
          days:{}
        };
      }
      const dataUpdate = {
        venueId: venueId,
        menuName: menuName,
        data: orderType
      }

      $.ajax({
        url: "/menus/setup/ordertype",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(dataUpdate),
        success: function (res) {
            if (res.code==0){
              setSettingMenu();
              let hasTimeOrder = validateHoursMenus(hourInfor);
              if(!hasTimeOrder){
                let daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
                let _time = hourInfor.days[daysOfWeek[moment().day()]];
                toastr.options = {
                  "timeOut": "5000",
                  "positionClass": "toast-bottom-center",
                }
                orderType.shift();
                return toastr.error(`We can't turn ${orderType.join(', ').toUpperCase()} on right now, because its ${moment().format('hh:mma')} and the hours this menu is served today are ${_time.fromTime} - ${_time.toTime}`);
              }
              toastr.success("Save success");
            } else {
              toastr.error("Save failed");
            }
        },
        error: function (e) {
          toastr.error("Save failed");
          console.log(e);
        }
      })
    }
  })
}



// ---------------------------------------------------

function scroll_to_menu_item($elem){
  if(!$elem || $elem.is(":hidden")){
   console.log("in scroll_to_menu_item.element not available or hidden..", $elem);
// not showing this maybe it is in top rated 7 and only 6 are being displayed   return toastr.warning('Item or action is unavailable!')
   return;
  };
  let heightscroll='';
  scrollCount++;
  let winwidth = $(window).width()
  if($elem.offset()){
    if($( ".m-menu-sub-tabs" ).hasClass( "sticky" )){
       heightscroll =$elem.offset().top-110;
    }else{
      if(scrollCount == 1 && winwidth < 500) {
        console.log("first scroll=======99999")
        heightscroll =$elem.offset().top-250;
      } else {
        heightscroll =$elem.offset().top-170;
      }
    }
  } else {
    console.log("no offset defined for elem...",$elem);
  }
console.log("in scroll_to_menu_item...", heightscroll);
  let collapse_elem = $elem.attr('data-target')
  $(collapse_elem).collapse('show')
   let margin_content = $('.restaurant-menu-infor').css('marginLeft');
    let width_content = $('.restaurant-menu-infor').width();
    $('.menu-items-bar').addClass('sticky');
    $('.menu-items-bar').css({'top': header_height-4, 'left': margin_content, 'width': width_content, 'max-width': '100%', 'padding': 0});

  return $('html, body').animate({
    scrollTop: heightscroll - $('.m-menu-sub-tabs').height()
  }, 1000, function(){
    $('html, body').animate({
      scrollTop: heightscroll - $('.m-menu-sub-tabs').height()
    },0)
  })

}
function render_menu_sub_tabs(nodes, show=true, activeMenu){
  $('.m-menu-sub-tabs').html('');
  let SUB_MENU_TABS = {
    element: '.m-menu-sub-tabs',
    key: Math.random().toString(36).substring(2),
    class: ['sub-tabs'],
    tabs: null,
  }
  if(!show) SUB_MENU_TABS.style['display'] = 'none';
  let tabs = [
    {
      title: 'Recommended',
      key: 'favorites',
      func: () => {return navigate_sub_tabs('favorites') }
    }
  ];
  let key = 0;
  _.forEach(nodes,(node)=>{
    _.forEach(node, (item)=>{
      if(!_.includes(['menu'], item.type)) return true;
      let tab = {
        title: item.title.toLowerCase(),
        key: key,
        data: {'node-key': item.setup._id},
        menuName:  item.setup.menuName,
        func: () => {return navigate_sub_tabs("menusection_"+tab.key) }
      }
      key++;
      tabs.push(tab);
    })
  })
  SUB_MENU_TABS.tabs = tabs;
  const searchParams = new URLSearchParams(preUrl);
  const collapse = searchParams.get('collapse');
  const type = searchParams.get('type');
  const clickParam = searchParams.get('click');
  if(collapse && type) {
    SUB_MENU_TABS.active = { key: type === 'favorites' ? 0 : 1, immediate: false };
    const userHasDietaryPreferences = $('#dietary-preferences').text().trim();
    SUB_MENU_TABS.rendered = () => {
      if(type === 'favorites') {
        $('html, body').animate({ scrollTop: $(`div#${collapse}`).offset().top - $('.m-menu-sub-tabs').height() }, 1000);
      } else {
        $('html, body').animate({ scrollTop: $(`li#menu-node-id-${collapse}`).offset().top - $('.m-menu-sub-tabs').height() }, 1000);
      }
      if(userHasDietaryPreferences !== 'false' && clickParam) $(`button.meets-preferences-item-${collapse}`).click();

    }
  }
  __navigation(SUB_MENU_TABS, false, activeMenu);
}
function navigate_sub_tabs(key){
   let header_height = $('#header').height();
  if(key == 'favorites'){
    $('html, body').animate({
      scrollTop: $(`#favorites-menu`).offset().top - header_height - 200
    }, 1000, function(){
      $('html, body').animate({
        scrollTop: $(`#favorites-menu`).offset().top - header_height - 200
      },0)
    })
    return
  }
  let this_node = $('#'+key);
  if(!this_node) return false;
 /* redesign this_node.parent.setExpanded(true);
  this_node.setExpanded(true);
  */
  scroll_to_menu_item(this_node)
}
/* end code here*/
function filtertab_clicked(value){
  if(value=='later'){
    $('.show-if-later').show();
    sessionStorage.filter_by_datetime = $('.available-items-datetime').val();
    sessionStorage.filter_now_or_later = 'later'
  }else{
     $('.show-if-later').hide();
     sessionStorage.filter_now_or_later = 'now'
  }
  if(dataTree != undefined) $('.show-available-items').trigger('change')
}

$('#restaurant-favorite-filter').on('show.bs.collapse', function(){
  $('html, body').animate({
    scrollTop: $(`#menu-search`).offset().top - 170
  }, 1000)
})
const currentUrl = window.location.href;
const preUrl = document.referrer;



  function setSettingMenu(options = {}) {

    const menus = dataTree.map((tree) => tree.title);
    const menuData = dataTree.map((tree) => tree.children);

    refreshMenuDiscount({ fetch: false });
    let showing_time = {
      date: moment().format('MM/DD/YYYY'),
      time: moment().format('hh:mma')
    }
    if (options.at_specific_time) {
      let dt = options.at_specific_time
      showing_time = {
        date: dt.substr(0, 10),
        time: dt.substr(11, 7)
      }
    }

    let show = null;
    let room = null;
    let crm = null;
    let sharing = null;

    let url = new URL(window.location.href);
    if (url.searchParams) {
      show = url.searchParams.get('show');
      room = url.searchParams.get('room');
      crm = url.searchParams.get('crm');
      sharing = url.searchParams.get('sharing');

      if (show) {
        if ($(`#heading${show}`).offset()) {
          $('html, body').animate({ scrollTop: $(`#heading${show}`).offset().top }, 500);
        }
        $(`#collapse${show}`).collapse('show');

      }
    }
    return getSetupMenus(menus)
      .then(res => {
        init_menu_setting_elevation()
        sessionStorage.menu_hour = JSON.stringify(res.data.setupMenus);
        let { setupMenus, admin } = res.data
        if (!_.size(setupMenus)) return false
        let MENU_DATA = JSON.parse($('#tree-data').val())

        let ACTIVE_MENUS = []
        let ACTIVE_ITEMS = []
        _.forEach(MENU_DATA, item => {
          let setting = _.find(setupMenus, el => el.menuName == item.title)
          let setting_time = setting ? setting.hours : '';
          let showing = show_available_items(setting_time, showing_time);
          if (!showing) return true
          ACTIVE_MENUS.push(item.title)
          _.forEach(item.children, elem => {
            ACTIVE_ITEMS = _.concat(ACTIVE_ITEMS, _.map(elem.children, el => el.key))
          })
        })

        $.each($(".menuheading_parent"), function(index, item){
          if(!_.includes(ACTIVE_MENUS,$(item).data('menu-key'))){
            $(item).find('.list-menu-items').hide()
            $(item).find('.alert').show()
          } else {
            $(item).find('.list-menu-items').show()
            $(item).find('.alert').hide()
          }
        })
        // commenting for show toprated mentitems correctly
        // let $favorite_items = $('#favorites-menu-items').find('.restaurant-menuitem')
        // $.each($favorite_items, function(index, item){
        //   let key = $(this).data('key')
        //   if(!_.includes(ACTIVE_ITEMS, key)) $(this).hide()
        // })

        dataTree.map(tree => {
          let menus = setupMenus.filter(menu => _.toString(tree.title) == _.toString(menu.menuName));
          let children = [];
          if (tree.children && tree.children.length) {
            children = tree.children.filter(child => child.type !== 'setup')
            children = setupMenuItems(children, menus[0]);
          }
          if (menus && menus[0]) {
            const menu = menus[0];
            menu.admin = admin;
            const orderType = { data: menu, type: "setup-type" }
            const images = { data: menu, type: "setup-slider" }
            const hours = { data: menu, type: "setup-hours" }
            let setting_time = hours.data.hours;
            let showing = show_available_items(setting_time, showing_time);
            if (!showing) children = {};
          }
        })

        __menu.source = dataTree
        render_menu_tabs(setupMenus);
        render_menu_sub_tabs(menuData,true, ACTIVE_MENUS);
        __menu.time = true

        if (scroll_to_menuitem_key) {
          let $favorite_item = $('#favorite_' + scroll_to_menuitem_key);
          let $regular_item = $('#' + scroll_to_menuitem_key);
          if ($favorite_item.length) return scroll_to_menu_item($favorite_item)
          else return scroll_to_menu_item($regular_item)
        } else if (window.location.href.toString().match(/restaurant/i) && !_userTakesControl && !room && !crm) { // If restaurant page, scroll to menu
          let tab = getTab("tab");
          if (tab !== 'restaurantOrder') {
            go_to_heighest_or_regular_menu()
          }
        }
      })
  }

const user_login = $('#is-logged-in') && $('#is-logged-in').val() || false;
var allOrderTpes = $('#allOrderTypes') && $('#allOrderTypes').val() || false;
allOrderTpes = JSON.parse(allOrderTpes);
let orderTypes = ["rate"]
if(allOrderTpes && allOrderTpes.isPickupOrder) orderTypes.push("pickup");
if(allOrderTpes && allOrderTpes.isDeliveryOrder) orderTypes.push("delivery");
if(allOrderTpes && allOrderTpes.isOrderAhead) orderTypes.push("orderAhead");
console.log("allOrderTpes===",allOrderTpes)
if(allOrderTpes.isOrderAhead ){

  $("#orderaheadcss").removeClass('orderaheadcss')
}else{

  $("#orderaheadcss").addClass('orderaheadcss')
}
if(allOrderTpes.isDeliveryOrder){
  $("#deliverycss").removeClass('orderaheadcss')
}else{
  $("#deliverycss").addClass('orderaheadcss')
}
if(allOrderTpes.isPickupOrder){
  $("#pickupcss").removeClass('orderaheadcss')
}else{
  $("#pickupcss").addClass('orderaheadcss')
}
var shopping_icon='';
if(orderTypes && orderTypes.length ==1){
  shopping_icon='<i class="fas fa-clipboard-list" aria-hidden="true"></i>';
}else{
  shopping_icon='<i class="fa fa-shopping-cart" aria-hidden="true"></i>';
}
var menu_bar_offset = $('.m-menu-sub-tabs').offset() ? $('.m-menu-sub-tabs').offset().top : '';
let header_height = $('#header').height();
fixed_menu_section();
$(document).scroll(function() {
  fixed_menu_section()
});

$('.show-available-items').find('.nav-link').removeClass('active')
if(sessionStorage.filter_now_or_later == 'later'){
  $('.show-available-items').find(`.items-available-later`).find('a').addClass('active');
  $('.show-if-later').show();
}else{
  $('.show-available-items').find(`.items-available-now`).find('a').addClass('active');
}

$('.show-available-items').on('change', function(){
  return setSettingMenu()
})

$('body').append('<button style="display: none;" id="call-setting-menu">Call</button>');
/* redesign 15267
$('#call-setting-menu').on('click',function(){
  reload_data_tree();
})

function reload_data_tree(){
  let height_regular_menu = $('#regular-menu').height();
  $('#regular-menu').css('min-height',height_regular_menu)
  $("#tree").fancytree("getTree").reload(dataTree).done(function(){
    setTimeout(()=>{
       $('#regular-menu').removeAttr('style');
    }, 5000);
  });
}
*/

function fixed_menu_section(){
  if(!$('.menu-items-bar').hasClass('sticky')){
    menu_bar_offset = $('.menu-items-bar').offset() ? $('.menu-items-bar').offset().top - header_height : 0;
  }
  menu_bar_offset =   Math.abs(menu_bar_offset);
  if($(window).scrollTop() > menu_bar_offset){
    let margin_content = $('.restaurant-menu-infor').css('marginLeft');
    let width_content = $('.restaurant-menu-infor').width();
    $('.menu-items-bar').addClass('sticky');
    $('.menu-items-bar').css({'top': header_height-4, 'left': margin_content, 'width': width_content, 'max-width': '100%', 'padding': 0});
  }else{
    $('.menu-items-bar').removeClass('sticky')
    $('.menu-items-bar').attr('style', '')
  }
  return rerender_navbar()
}
// Rerender menu item for each screen size.
/* mangita do we need this */
var timeout_elem;
var original_browser_width = window.innerWidth
$( window ).resize(function() {
  if(window.innerWidth < 600 && original_browser_width < 600) return original_browser_width = window.innerWidth
  if(window.innerWidth > 600 && original_browser_width > 600) return original_browser_width = window.innerWidth
  original_browser_width = window.innerWidth
  window.clearTimeout(timeout_elem);
  // return timeout_elem = window.setTimeout(()=>{ reload_data_tree(); }, 500);
});
//
var MEETS_PREFERENCES = null;

$('.choose-suitable-dish').on('click', function(){
  let litags = $(this).parent().find('li');

  litags.removeClass('active');
  $(this).addClass('active');

  litags.css({'background-color': 'white'})
  litags.find('a').css({'color': 'black'})

  $(this).find('a').css({'color': 'white'});

  switch($(this).data('value')) {
    case 'yes':
      $(this).css({'background-color': '#4caf50'})
      break;
    case 'no':
      $(this).css({'background-color': '#ff5722'})
      break;
    case 'canrequest':
      $(this).css({'background-color': '#ffc107'})
      break;
    case 'notsure':
      $(this).css({'background-color': '#9e9e9e'})
      break;
    case 'mostly':
      $(this).css({'background-color': '#8bc34a'})
      break;
    case 'na':
      $(this).css({'background-color': '#9e9e9e'})
      break;
    default:
      // code block
  }
  let infor = {
    item_id: $(this).parent().data('item-id'),
    preference: $(this).parent().data('preference'),
    value: $(this).data('value'),
    hide: true
  }
  return save_my_food_preferences(infor);
})





  function getMatch(a,b){
    let value = b.diff(a);
    return value;
  }

  Array.prototype.diff = function(a) {
     return this.filter(function(i) {return a.indexOf(i) < 0;});
  };

// ******************************************************
//
  var myRating='';
  var evrageRating='';
  var myReview='';
  var evrageReview='';
  var venueParams = {
    name: $('#venue-name').text().trim(),
    slug: $('#venue-slug').val(),
    location: $('#venue-location').text().trim(),
    lat: $('#venue-lat').text().trim(),
    lng: $('#venue-lng').text().trim(),
    phone: $('#venue-phone').text().trim(),
    venueId: $('#venue-id').text().trim()
  };

  var RESTAURANT_MOD = undefined;
  if (restaurantModule && !RESTAURANT_MOD){
    RESTAURANT_MOD = new restaurantModule();
    RESTAURANT_MOD.init();
  }

  let userId = $('#userId').val() ? $('#userId').val() : false;
  $(document).ready(function(){ //important for the restaurant menu tree
    let current_url = window.location.href;

    let url_paramrs = _.split(current_url,'#');

    let order_ahead = false;
    if(_.includes(current_url,"order_id") && _.includes(current_url,"MyOrder")){
      order_ahead = true;
    }else{
      return
    }
    if(!userId && order_ahead) {
      document.getElementById('login-platerate').click()
    }
  })
  let MenuItemDiscount = [];
  /**
   * Create the tree inside the <div id="tree"> element.
   *
   */
  var $tree = $('#tree');
  var MenuTimeSettingInit = null;
  var ItemDiscountInit = [];
  try{
    MenuTimeSettingInit = JSON.parse($('#menu-time-setting').val())
    ItemDiscountInit = JSON.parse($('#item-discounts').val())
  }catch(err){
    console.log("Could not get data from MenuTimeSettingInit...",err);
  }

  const venueId = venueParams.venueId;
  const slug = venueParams.slug;
  const $ratingsForm = $('<form>', {
    method: 'GET',
    action: '/ratings/edit/' + venueId
  });
  function getNoCooperativeRestaurant(venueIdParam){
    return $.promisedAjax({
      url   : '/restaurantadmin/getNoCooperativeRestaurant',
      type: 'POST',
      data: JSON.stringify({
        venueId: venueIdParam,
      }),
      contentType: 'application/json',
      dataType: 'json'
    })
  };
  function getVenueRequested(venueIdParam){
    return $.promisedAjax({
      url   : '/salescrm/getVenueRequested',
      type: 'POST',
      data: JSON.stringify({
        venueId: venueIdParam,
      }),
      contentType: 'application/json',
      dataType: 'json'
    })
  };
  window.refreshMenuDiscount = function (options = {}){
      let fetch = options.fetch == undefined ? true : options.fetch
      return new Promise(function(resolve, reject) {
         if (fetch)
         return resolve(getItemsDiscounts({venueId : venueId, userId: userId}))
        return resolve({code: 0, data: ItemDiscountInit})
      }).then(results => {
         let isSelectedNoButton = false;
          let isSelectedYesButton = false;
          if(userId){
            Promise.all([getVenueRequested(venueId), getNoCooperativeRestaurant(venueId)]).then((getButtonSelected) => {
              const [getYesButtonSelected, getNoButtonSelected] = getButtonSelected;
              isSelectedNoButton = !_.isEmpty(getNoButtonSelected.data);
              isSelectedYesButton = !_.isEmpty(getYesButtonSelected.data);
            });
          }
          if (results.code == 0){
            if (!Array.isArray(results.data)) MenuItemDiscount = [results.data]; // For one case that discount API return 1 object instead of an array
            else MenuItemDiscount = results.data;
            let max_discount = _.maxBy(results.data, function(o) { return o.maximumDiscount; }) || 0;
            let customerRatingRestaurant=0;
            if(max_discount && max_discount.eligibleDiscounts && max_discount.eligibleDiscounts.customerRatingRestaurant){
             customerRatingRestaurant= Number(max_discount.eligibleDiscounts.customerRatingRestaurant)-Number(max_discount.eligibleDiscounts.customerFirstMenuItemRating ? max_discount.eligibleDiscounts.customerFirstMenuItemRating :0);
            }
            let data={'maximumDiscount':max_discount.maximumDiscount,'customerFirstTimeOrder':max_discount.eligibleDiscounts && max_discount.eligibleDiscounts.customerFirstTimeOrder ? max_discount.eligibleDiscounts.customerFirstTimeOrder : 0,'customerFirstExpertReview':max_discount.eligibleDiscounts && max_discount.eligibleDiscounts.customerFirstExpertReview ? max_discount.eligibleDiscounts.customerFirstExpertReview : 0,'customerFirstMenuItemRating':max_discount.eligibleDiscounts && max_discount.eligibleDiscounts.customerFirstMenuItemRating ? max_discount.eligibleDiscounts.customerFirstMenuItemRating : 0,'customerRatingRestaurant':max_discount.eligibleDiscounts && max_discount.eligibleDiscounts.customerRatingRestaurant ? max_discount.eligibleDiscounts.customerRatingRestaurant : 0};
            $("#maximumDiscountDiv").attr("data-discount",JSON.stringify(data));
            showInstructionPopUp(max_discount.maximumDiscount, isSelectedNoButton, isSelectedYesButton)

            if(dataTree){

              setDiscountMenu(dataTree);
            }
            else{
              console.log("not data tree, hence discount not being set=.")
            }
            __menu.source = dataTree
            __menu.discount = true
          }
          else {
            console.log("in refreshMenuDiscount..resultcode not zero=.",results)
          }
      })
  }
  function showInstructionPopUp(maximumDiscount){
    showMenuInstructionPopUp();
    let _notShowMenuItemInstruction = sessionStorage._notShowMenuItemInstruction || '';
    checkRestaurant(venueId).then( isCheck => {
      if(isCheck){
        if(maximumDiscount && maximumDiscount>0){
          $('.max-discount-number').text(maximumDiscount);
          $('#highest-credits-info').text(maximumDiscount);
          if(_notShowMenuItemInstruction.search(venueId) == -1 && localStorage.getItem('_showMenuItemInstruction') == 'true'){
            $('.modal-instruction-component').find('.content-model-instruction').html(`WHEN you buy food using the PlateRate app AND rate your menu items you EARN a credit of up to <span style="font-size: 20px; font-weight: bold" class="max-discount-number"><i class="fa fa-spinner fa-spin"></i> </span>% in free food/drinks (valid for 3 month(s)) on your NEXT ORDER.`);
            $('.modal-instruction-component').find('#footer-model-instruction').html(`<a id="stop-showing-instruction-box" class="btn" style="font-size: 16px; float: left">Never show again</a>
            <button id="instruction-confirm" type="button" class="btn btn-success" style="font-size: 20px">
              Got it!
            </button>`);
            $("#modal-instruction").modal({backdrop: 'static', keyboard: false});
            $("#modal-instruction").find('.collapse').css('display','block');

          }
        }else{ //dont show discount flip if dicount =0
          $('#highest-credits-info').text(0).parent().attr("data-target", "");
          $('.max-discount-number').text(0);
          $('#credit_discount_earn').text('');
        }
      }else{
        $('#credit_discount_earn').text('');
        $('.max-discount-number').text(0);
        if(_notShowMenuItemInstruction.search(venueId) == -1){
          $('.modal-instruction-component').find('.content-model-instruction').html(`PlateRate can get you up to a 60% credit in free food at this restaurant. Do you want this restaurant to partner with PlateRate?`);
          $('.modal-instruction-component').find('#footer-model-instruction').html(`<button type="button" class="btn no-partner-restaurants" style="color: #d9534f !important;background: #fff !important;border: 1px solid #d9534f !important;">NO</button>
              <button type="button" class="btn partner-restaurants" style="color: mediumseagreen !important;background: #fff !important;border: 1px solid mediumseagreen !important;">YES</button>`);
               $("#modal-instruction").modal({backdrop: 'static', keyboard: false});
               $("#modal-instruction").find('.collapse').css('display','block');
        }
        hightLightButtonPartner();
        $('#menu-order-instruction').find('.content-model-instruction').text("PlateRate can get you up to a 60% credit in free food at this restaurant. Do you want this restaurant to partner with PlateRate?");
        $('#menu-order-instruction').find('.content-model-instruction').parent().parent().append(
          `<p class="text-center">
              <button type="button" class="btn no-partner-restaurants" style="color: #d9534f !important;background: #fff !important;border: 1px solid #d9534f !important;">NO</button>
              <button type="button" class="btn partner-restaurants" style="color: mediumseagreen !important;background: #fff !important;border: 1px solid mediumseagreen !important;">YES</button></p>`);
        $('#menu-order-instruction').on('click','.no-partner-restaurants', function(){
          noCooperativeRestaurant();
        });
        $('#menu-order-instruction').on('click','.partner-restaurants', function(){
          salecrmRestaurant();
        });
      }
    });
  }
  function hightLightButtonPartner(){
    let venueId = $('#venue-id').text().trim();
    let userId = $('#userId').val();
    if(userId){
      getVenueRequested(venueId).then(getButtonSelected => {
        if(getButtonSelected && getButtonSelected.data && getButtonSelected.data.venue && getButtonSelected.data.venue.requested_by){
          getButtonSelected.data.venue.requested_by.forEach((item) => {
            if(item.user_id == userId){
              $('.partner-restaurants').attr('style','');          //   return;
              $('.partner-restaurants').addClass('enable');
            }else{
              $('.partner-restaurants').attr('style','color: mediumseagreen !important;background: #fff !important;border: 1px solid mediumseagreen !important;');
            }
          })
        }
      });
      getNoCooperativeRestaurant(venueId).then(getButtonSelected => {
        if(getButtonSelected && getButtonSelected.data && getButtonSelected.data.listNoCooperative){
          let check = getButtonSelected.data.listNoCooperative.indexOf(userId);
          if(check >=0){
            $('.no-partner-restaurants').attr('style','background: #d9534f !important;');
            $('.no-partner-restaurants').addClass('enable');
          }else{
            $('.no-partner-restaurants').attr('style','color: #d9534f !important;background: #fff !important;border: 1px solid #d9534f !important;');
          }
        }
      });
    }
  }

  function checkRestaurant(venueId) {
    return $.promisedAjax({
      url: `/users/profile/checkRestaurant/${venueId}`,
      type: 'GET',
      contentType: 'application/json; charset=utf-8'
    })
  }
 
  var maxFlavourFilterForMenuItems = 80;
  var myRatings = [];

  try {
    dataTree = JSON.parse($('#tree-data').val())
    let spclInstInStorage = localStorage.getItem("specialInstructions2_")
    let spclInstrObj = JSON.parse(spclInstInStorage)

    if(spclInstInStorage && spclInstrObj && spclInstrObj.spclInstr && spclInstrObj.spclInstr != '' && !document.referrer.includes("setFoodPrefProfile&buymenuitemid")){  
    let nodesub = $("#menuitemData_" + spclInstrObj.menuitem);
    if (nodesub) {
      nodesub = nodesub.val();
       setTimeout(function(){
          showItemModal(nodesub);
          $('#modal-order-item-addons').find('.modal-item-special-instructions').val(spclInstrObj.spclInstr);
          // localStorage.removeItem("specialInstructions2_")
  	   }, 1000)    
     } else {
      console.log("order-this-item menuitemData_ not found for ...", id);
    }
    }
  }catch(err){
    console.log("Could not get data from div tree...",err);
    dataTree = []
  }
  __menu.source = dataTree
  try{
    MEETS_PREFERENCES = JSON.parse($('#meets-preferences-infor').val());
  }catch(err){
    console.log("NOT ABLE TO GET MEETS_PREFERENCES..",err);
  }



  try{
    myRatings = JSON.parse($('#myRatings').val())
  }catch(err){
    console.log("NOT ABLE TO GET myRatings...",err);
  }

  setSettingMenu({fetch:false});
  //refreshMenuDiscount({fetch:false});

// need for dicount in new design
function setDiscountMenu(data){
  if (data instanceof Array){
    for(let i = 0; i < data.length; i++){
      setDiscountMenu(data[i]);
    }
  } else {
    if (data.folder === true){
      setDiscountMenu(data.children)
    } else {
      let discount = MenuItemDiscount.find(d => d.menuItemId == data.key);
      // let discount = MenuItemDiscount && MenuItemDiscount.menuItemId ? MenuItemDiscount.menuItemId == data.key : '';
      if (discount){
        let _discount = discount.maximumDiscount || 0;
        data['discount'] = _discount;
      }
    }
  }
}

function show_available_items(setting_time, showing_time) {
  if (setting_time.anyTime) return true;

  let daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  let _d = daysOfWeek[moment(showing_time.date, 'MM/DD/YYYY').day()];

  let theday = setting_time.days[_d];

  // If the day does not exist in the settings or is not available, return false
  if (!theday || !theday.isAvailable) return false;

  let set_from = theday.fromTime;
  let set_to = theday.toTime;

  let selectedTime = moment(`${showing_time.date} ${showing_time.time}`, 'MM/DD/YYYY hh:mma');
  let fromTime = moment(`${showing_time.date} ${set_from}`, 'MM/DD/YYYY hh:mma');
  let toTime = moment(`${showing_time.date} ${set_to}`, 'MM/DD/YYYY hh:mma');

  // Check if the selected time is within the available time range
  return selectedTime.isBetween(fromTime, toTime, null, '[]');
}

$('.available-items-datetime').click((e) => {
  $('.available-items-datetime').parent().find('.input-group-addon').trigger('click');

  });

$('.available-items-datetime').val(sessionStorage.filter_by_datetime || '')

$('.filter-datetime-item').datetimepicker({
  stepping:15,
  showClose: true,
  icons: {
    close: 'closeText'
  }
});
$('.filter-datetime-item').on('dp.change', function(e) {
  $('.available-items-datetime').val(e.date.format('MM/DD/YYYY hh:mma '));
  sessionStorage.filter_by_datetime = $('.available-items-datetime').val();
  return setSettingMenu()
});

function showAvailableItemsOnHighestRating(){
  let fav_show_limit = $("#favorite-menu-show-limit").val();
//redesign  let tree_source = $('#tree').fancytree("getTree");
  $.each($('.menuItems'),(index, element)=>{
    let hideOnDefault = (index >= fav_show_limit)
    let key = $(element).data('entry-id');
    let show_not_meet = $('#show-food-not-meet').prop('checked');
    let node = $('#tree #'+key);
    if(node && node.attr(hidden) == false){
      $(element).attr('data-available-now', 'true')
      if(!show_not_meet || (show_not_meet && $(element).data('meets') != 'no')){
        $(element).show();
      }
      if (hideOnDefault) $(element).hide();
    }else{
      $(element).attr('data-available-now', 'false')
      $(element).hide();
    }
  })

  // Favorite menu expander show/hide
  if ($('.menuItems').length > fav_show_limit) {
    favorite_menu_expander_display('show')
  } else {
    favorite_menu_expander_display('hide')
  }
}

function favorite_menu_expander_display(display){
  if (display == 'show'){
    $("#favorite-see-all").show('slow')
    $("#favorite-see-less").hide('slow')
    $('.hideOnDefault').fadeOut();
    $('.favorite-item:not(.hideOnDefault)').show('slow')
  } else if (display == 'hide'){
    $('#favorite-see-all').hide('slow')
    $("#favorite-see-less").hide('slow')
  }
}


$('#favorite-see-all').click((e) => {
  $('.hideOnDefault').fadeIn()
  $('#favorite-see-all').fadeOut('fast', function(){
    $('#favorite-see-less').fadeIn('fast');
  });
});

$('#favorite-see-less').click((e) => {
  $('.hideOnDefault').fadeOut()
  $('#favorite-see-less').fadeOut('fast', function(){
    $('#favorite-see-all').fadeIn('fast');
  });
});


  function getSetupMenus(menus){
    return $.promisedAjax({
      url   : '/menus/getSetup',
      type: 'POST',
      data: JSON.stringify({
        menus : menus,
        venueId : venueParams.venueId,
      }),
      contentType: 'application/json',
      dataType: 'json'
    })
  };

  function setupMenuItems (dataTree, data) {
    if(dataTree && dataTree.length) {
      dataTree.map((tree) => {
        setupMenuItems(tree.children, data);
        if(tree.type !== 'setup') {
          tree.setup = data;
        }
      })
    }
    return dataTree;
  }

  function reloadMenuSetup(expand) {
    setSettingMenu({expand});
  }




  function setYourTaste(data, tastes){
    if (data instanceof Array){
      for(let i = 0; i < data.length; i++){
        setYourTaste(data[i], tastes);
      }
    }else{
      if (data.folder === true && data.children[0] && data.children[0].type !== 'item'){
        setYourTaste(data.children, tastes)
      } else {
        if(data.children && data.children.length) {
          data.children.forEach((item) => {
            item['taste'] = 0;
            tastes.forEach((result) => {
              if(item.key == result.menuItemId) {
                item['taste'] = result.taste;
              }
            })
          })
        }
      }
    }
  }



  function getItemsDiscounts(params = {}){
    return $.promisedAjax({
      url   : '/getItemsDiscounts',
      type: 'POST',
      data: JSON.stringify({
        venueId     : params.venueId,
        userId      : params.userId,
        pagetype:'rest'
      }),
      contentType: 'application/json',
      dataType: 'json'
    })
  };



/* redesign not sure if we need this
function navigate_tabs(key){
  let tree = $('#tree').fancytree("getTree").getNodeByKey(key);
  let first_key = '';
  _.forEach(tree.children, (item)=>{
    if(item.type != 'menu') return true;
    first_key = item.key;
    return false
  })
  scroll_to_menu_item($(`#menu-infor-${key}`));

  if(!first_key) return toastr.warning("No item's available now");
  let element = $('.sub-tabs').find(`div[data-node-key="${first_key}"]`)
  try {
    $('.sub-tabs').animate({scrollLeft: element.position().left}, 500);
  } catch(e){
    return false;
  }
}
*/
// ------------------------------------------------------------------------


// -------------------------------------------------------------------------------
// -------------------------------------------------------------------------------
  function render_my_preferences(key, votes, subType){
    let account = '';
    try {
      account = JSON.parse($('#account-infor').text());
    } catch (error) {
      account = false;
    }
    let venue_slug = $('#venue-slug').val()
    if(!account) return `<a class="green sm-text" href="/users/login?next=/restaurant/${venue_slug || venueId}&tab=collapseFoodPref&type=${subType}&collapse=${key}"> Log In</a>`;
    let html = '';
    //let selecteddietpreferences =$('#dietaryPreferences').val();
    // console.log("selected diet pref.....",selecteddietpreferences);

    account.dietaryPreferences.forEach((ele)=> {
      if(ele.name){
        html += `
        <div class="form-group mb-0">
          <div class="foodpref-font">Is this dish ${ele.name}?</div>
          <ul class="select-suitable-list d-flex justify-content-between pl-0 mb-0" data-item-id="${key}" data-preference="${ele.name}">
              <li class="select-suitable-dish text-center" data-value="yes" style="background-color: ${votes == 'yes' ? '#4caf50' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">Yes</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="mostly" style="background-color: ${votes == 'mostly' ? '#8bc34a' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">Mostly</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="canrequest" style="background-color: ${votes == 'canrequest' ? '#ffc107' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">Can Request</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="notsure" style="background-color: ${votes == 'notsure' ? '#9e9e9e' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">Not Sure</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="no" style="background-color: ${votes == 'no' ? '#ff5722' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">No</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="na" style="background-color: ${votes == 'na' ? '#9e9e9e' : 'white'};">
                  <a class="text-black" href="javascript:void(0)">N/A</a>
              </li>
            </ul>
          </div>
        `;
      }
    })
    return html;
  }

//show discount flip
 $(".show-explaining-credits").click(function(event){
      event.stopImmediatePropagation();
      let ITEM = $(this);
      render_explaining_credits(ITEM);
  })

  $(".right_dc_item").click(function(event){
    event.stopImmediatePropagation();
    let ITEM = $(this).parents('.particular-menu-item').find('.show-explaining-credits');
    render_explaining_credits(ITEM);
  })
  $(document).on('click','body .card_earnup_item',function(event){
    event.stopImmediatePropagation();
    
    let id=event.target.id;
    let ITEM = $('#favorite_'+id).find('.show-explaining-credits');
    render_explaining_credits(ITEM);
  })
function render_explaining_credits(ITEM){
  const discountOptions = {
    userId      : $('#userId').val() || null,
    venueId     : $('#venue-id').text().trim(),
    menuItemIds : ITEM.data('item-id'),
  };
  if(ITEM.parent().find('.toggle-breakdown').length > 0 ){
    ITEM.parent().find('.toggle-breakdown').slideToggle();
  }else{
  /* why getting data again, already got via  refreshMenuDiscount
    $.ajax({
      url: "/getItemsDiscounts",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(discountOptions),
      success: function (res) {
        console.log("discount from getItemsDiscounts...",res.data);
        let _discount =  res.data.eligibleDiscounts;
      */
        let _discount = {};
        let discounts = MenuItemDiscount.filter(x=>x.menuItemId == discountOptions.menuItemIds);
        if(discounts && discounts.length > 0){
          _discount = discounts[0].eligibleDiscounts;
        }
        let firstExpertReviewAmt = parseFloat(_discount.customerFirstExpertReview || 0);
        let firstMenuItemRatingAmt = parseFloat(_discount.customerFirstMenuItemRating || 0);
        let ratingRestaurantAmt = parseFloat(_discount.customerRatingRestaurant || 0);
        let totalCredit = (ratingRestaurantAmt > 0 ?_discount.customerRatingRestaurant : 0 )+ (firstMenuItemRatingAmt > 0 ?_discount.customerFirstMenuItemRating : 0 )+ (firstExpertReviewAmt > 0 ?_discount.customerFirstExpertReview : 0);
        ITEM.parent().parent().find('.explaining-credits').attr("data-target", "#discount_flip_div");
        ITEM.parent().parent().find('.explaining-credits').attr("data-discount", JSON.stringify(_discount));
        ITEM.parent().parent().find('.explaining-credits').trigger( "click" );
/*      },
      error: function (e) {
        return false;
      }
    }) */
  }
}

function render_expert_review(data){
  let itemFlavors = data['flavors'];
  let itemFlavorsLow = data['low'];
  let itemFlavorsHigh = data['high'];

  let html = `
    <div class="form-row form-group d-flex justify-content-between">
      <div><i class="fa fa-circle" aria-hidden="true" style="color: orange"></i> Dish Score</div>
      <div><i class="fa fa-circle" aria-hidden="true" style="color: green"></i> My preferences</div>
    </div>
    <div class="form-row form-group d-flex justify-content-between">
      <div style="font-weight: bold">Low</div>
      <div style="font-weight: bold">High</div>
    </div>
  `;
  try{
  for (let key in itemFlavors) {
      if (itemFlavors.hasOwnProperty) {
    let keyValue = key;
    if(keyValue == 'savory'){
      keyValue = 'Umami (meaty taste)';
    }else if(keyValue == 'valueForPrice'){
      keyValue = "What it's worth";
    }else if(keyValue == 'quantity'){
      keyValue = "Portion Size";
    }
        html += `
          <div class="row flavor-title">
            <div class="col-12" >${keyValue}</div>
          </div>
          <div class="row flavor-slider">
            <div class="col-12">
                <input type="text" class="range-slider-flavor"
                    data-provide="slider"
                    data-slider-value="[${itemFlavorsLow[key]},${itemFlavorsHigh[key]}]"
                    data-slider-selectedval="${itemFlavors[key]}"
                />
            </div>
          </div>
        `;
      }
  }
  }catch(err){ }
  return html
}

// Set menu handler
__menu.handler = ()=>{
/* redesign 15267
  $("#tree").fancytree("getTree").reload(__menu.source)
  */
  __load.menu = true
  showAvailableItemsOnHighestRating()
}

$('#heighest-sorl-filter').on('hidden.bs.collapse', function (e) {
    $(this).parent().find('button.btn-action-filter').text('Show Sorts/Filters');
})

$('#heighest-sorl-filter').on('show.bs.collapse', function (e) {
  $(this).parent().find('button.btn-action-filter').text('Hide Sorts/Filters');
})

$('#regular-menu-sorl-filter').on('hidden.bs.collapse', function (e) {
  $(this).parent().find('button.btn-action-filter').text('Show Sorts/Filters');
})

$('#regular-menu-sorl-filter').on('show.bs.collapse', function (e) {
  $(this).parent().find('button.btn-action-filter').text('Hide Sorts/Filters');
})



  $(document).on('mouseover', '.colorgreen', function() {
    if ($(this).parent('#mainRatingDiv').children('.colorOrange').text().length > 0 && $(this).is(':hidden') == false) {
     $(this).hide();
     $(this).parent('#mainRatingDiv').children('.colorOrange').show();
   }
  });
  $(document).on('mouseleave', '.colorOrange', function(e) {
    if ($(this).parent('#mainRatingDiv').children('.colorgreen').text().length > 0 && $(this).parent('#mainRatingDiv').children('.colorgreen').attr('id').length > 0) {
      $(this).hide();
      $(this).parent('#mainRatingDiv').children('.colorgreen').show();
    } else {
      $(this).show();
    }
  });


  /**
   * Click upload photo image menu
   */
  var MENU_NAME = null;
  var $PROGRESSBAR = null;
  $('body').on('click', '.submit-menu-photo, .no-image-menu', function(){
    if(userIsLoggedIn && userId) {
      const menuName = $(this).data('menu-name');
      const $container = $(this).parents('.group-setup-menu');
      $PROGRESSBAR = $container.find('.progress .progress-bar');
      if(menuName) {
        MENU_NAME = menuName;
        $('.file-menu-photo').trigger('click');
        $PROGRESSBAR.css({width: '0%'}).text('');
        $container.find('.progress').show();
      }
    } else {
      swalRequiredLogin();
    }
  })

  $('.file-menu-photo').fileupload({
    paramName: 'file',
    pasteZone: null,
    add: function (e, data) {
      if (!$.validateImage({
        name: data.files[0].name,
        size: data.files[0].size
      })) {
        Swal.fire({
            title: "Invalid File Format",
            text: "You can only upload images in JPG, JPEG, PNG, GIF, or BMP formats. Image size must be less than 50MB.",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3cb371",
        });      
      } else {
        RESTAURANT_MOD.resizeImageShow(data, true);
      }
    },
    done: function (e, data) {
      const link = data.result.bucketLink;
      uploadImageMenu(link);
    },
    dataType: 'json',
    url: '/uploadRatingsImage',
    progressall: function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      $PROGRESSBAR.css({
        width: progress + '%'
      });
      $PROGRESSBAR.text(progress + '%');

      if (progress === 100) {
        $PROGRESSBAR.text('Processing image ...');
      }
    }
  })

  function uploadImageMenu(link) {
    if(venueId && MENU_NAME) {
      const dataUpdate = {
        venueId: venueId,
        menuName: MENU_NAME,
        data: {
          urlImage: link
        }
      }

      $.ajax({
        url: "/menus/setup/images",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(dataUpdate),
        success: function (res) {
          if (res.code==0){
            appenSlider(MENU_NAME, link);
            toastr.success("Save success");
          } else {
            toastr.error("Save failed");
          }
          MENU_NAME= null;
        },
        error: function (e) {
          toastr.error("Save failed");
          console.log(e);
        }
      })
    }
  }
  /**
   * Click change hourse
   */
  $('body').on('change', 'input.any-time-menu', function(){
    const $container = $(this).parents('div.group-menu-hours');
    const menuName = $container.data('menu-name');
    const anyTime = $container.find('input.any-time-menu').prop('checked') ? true : false;
    const hours = { anyTime: anyTime };
    if(venueId && menuName) {
      const dataUpdate = {
        venueId: venueId,
        menuName: menuName,
        data: hours,
        change: true
      }

      $.ajax({
        url: "/menus/setup/hours",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(dataUpdate),
        success: function (res) {
          if (res.code != 0) {
            $container.find('input.any-time-menu').prop('checked', !anyTime)
          } else {
            if(anyTime) {
              $container.find('.menu-hours').hide();
              reloadMenuSetup('hours_'+menuName);
            } else {
              $container.find('.menu-hours').show();
            }
          }
        },
        error: function (e) {
          console.log(e);
          $container.find('input.any-time-menu').prop('checked', !anyTime)
        }
      })
    }
  });

  /**
   * Click update hourse
   */

  $('body').on('click', '.btn-save-hours-menu', function(e){
    const $container = $(e.target).parents('div.group-menu-hours');
    const menuName = $container.data('menu-name');
    const hours = {
      anyTime: $container.find('input.any-time-menu').prop('checked') ? true : false,
    }
    let days_week = ['mon','tue','wed','thu','fri','sat','sun'];
    let days = {};
    // let days_time = $('#all-notif');
    days_week.forEach((value)=>{
        days[value]={};
        const dayhours = $container.find(`tr.${value}`);
        days[value]['fromTime'] = dayhours.find('.menu-from-hour').val() + dayhours.find('.menu-from-minute').val();
        days[value]['toTime'] = dayhours.find('.menu-to-hour').val() + dayhours.find('.menu-to-minute').val();
        days[value]['isAvailable'] = dayhours.find('.menu-unavailable').prop('checked') ? true : false
    })
    hours['days'] = days;

    if(venueId && menuName) {
      const dataUpdate = {
        venueId: venueId,
        menuName: menuName,
        data: hours
      }

      $.ajax({
        url: "/menus/setup/hours",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(dataUpdate),
        success: function (res) {
            if (res.code == 0) {
                reloadMenuSetup('hours_' + menuName);
                Swal.fire("Success!", '', "success");
            } else {
                Swal.fire("Oops!", '', "error");
            }
        },
        error: function (e) {
          console.log(e);
          Swal.fire("Oops", "Please try again and reload the page once!", "error");
        }
      })
    }
  })
/* redesign
  $($tree).on('blur', 'input[type="number"]', function($event){
    let minLength = $(this).attr('min');
    let maxLength = $(this).attr('max');
    let aux = $event.target.value;
    let value = Number(aux);
    minLength = Number(minLength);
    maxLength = Number(maxLength);
    if (isNaN(value)) value = 0;
    if(!isNaN(minLength) && minLength !== maxLength) value = minLength > value ? minLength : value;
    if(!isNaN(maxLength) && minLength <= maxLength) value = maxLength < value ? maxLength : value;

    aux = value.toFixed(0);
    $event.target.value = aux < 0 ? 0 : aux;
  })
*/

  function sortMenu(data, _arrSortFields){
      if (data instanceof Array){
        for(let i = 0; i < data.length; i++){
          sortMenu(data[i], _arrSortFields);
        }
      }else{
        if (data.folder === true && data.children && data.children.length > 0 && data.children[0] && data.children[0].type == 'item'){
        //console.log("data before sorting...",data.children);
//        data.children = _.orderBy(data.children, _arrSortFields, _arrSortType)

          data.children.forEach(function(item,itemkey){
             let getKey = item.key;
             let getData = ALL_FLAVOR_MATCH[getKey];
               if(Number(getData)>0){
                 data.children[itemkey].flavorMatch = getData;
               } else {
                 data.children[itemkey].flavorMatch = -1;
               }
           })

          const sortMenuRegular = function () {
            data.children.sort(function (a, b) {
              return sortFunction(_arrSortFields, a, b,false);
            });
          }
          sortMenuRegular()
//        console.log("data after sorting...",data.children);
       }

        if (data.folder === true && data.children[0] && data.children[0].type !== 'item'){
          sortMenu(data.children, _arrSortFields)
        }
      }
  }

  function saveSelection(itemId) {
  /* leaving localforage since not sure if it is being read in other places */
    localforage.getItem('selectedItems', function(err, items) {

      if(!items) {
        items = {};
      }

      items[itemId] = true;

      localforage.setItem('selectedItems', items);
    });
      let items1 = localStorage.getItem('selectedItems');
        //hack to reset when value is [object
        let isvalid=true;
        for( let [key, value]  in items1){
          if(!value){ //hack to reset when value is [object
            isvalid=false;
          }
        }

        if(!items1 || !isvalid) {
          items1 = [];
        }

        items1.push(itemId) ;
//you can only store strings in localStorage
        localStorage.setItem('selectedItems', JSON.stringify(items1));
  }

  window.saveSelection = saveSelection;

  function removeSelection(itemId) {
    localforage.getItem('selectedItems', function(err, items) {
      if(!items) {
        items = {};
      }

      items[itemId] = false;

      localforage.setItem('selectedItems', items);
    });
      let items1 = localStorage.getItem('selectedItems');
        if(!items1) {
          items1 = [];
        }

        var filtered = JSON.parse(items1).filter(function(value, index, arr){

            return value != itemId;

        });

        localStorage.setItem('selectedItems', JSON.stringify(filtered));
  }
  window.removeSelection = removeSelection;

  $ratingsForm.appendTo($tree);
/* redesign this also does not seem to be used anywhere
  const statusCrowdMenuItem = function(node) {
    if(node.enableMenu) {
      return `${node.menuType && Number(node.menuType) == 1
        ? `<a href="javascript:void()" class="active-menuitem-crowd" data-key="${node.key}"><span class="green"><i class="fa fa-square-o"></i>&ensp;Active</span></a>`
        : '<span class="">No</span>'}`
    } else {
      return `<span class="">${node.menuType && Number(node.menuType) == 1 ? 'Yes' : 'No'}</span>`
    }
  }

  $tree.on('click', '.active-menuitem-crowd', function() {
    const menuItemId = $(this).data('key');
    const changeHtml = $(this).parent();
    if(venueId && menuItemId) {
      swal({
        title: "Oops!",
        text: "Would you like to activate the menu item from crowd-sourced into the restaurant menu?",
        type: "warning",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: "Yes",
        confirmButtonColor: "#3cb371",
      }, function (comfirn) {
        if (comfirn) {
          $.ajax({
            type: "POST",
            url: '/menuitems/activemenuitemcrowd',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({venueId, menuItemId}),
            success: function (res) {
              if(res.data) {
                changeHtml.html('<span class="">No</span>');
                toastr.success("Activated success!");
              } else if(res.message) {
                toastr.error(res.message);
              }

            }
          }).catch((e) => {
          })
        }
      });
    }
  })
*/

  const selectItem = (items) => {
    let show = false;
    for(let item of items){
      if(item.type === 'item') {
       show = true;
       break;
      }
    }
    return show;
  }


var _locked = false;
var _lastCall = false;
var runOnScroll =  function(evt) {
  if(_locked) return _locked = true;
  if (_lastCall) clearTimeout(_lastCall);
  _lastCall = setTimeout(() => {
    _locked = false;
  }, 200);
};


$('body').append('<div class="modal-instruction-component"></div>')
function showMenuInstructionPopUp () {
  let venueId =  $("#venueId").val();
  if (localStorage.getItem('_showMenuItemInstruction') == null || localStorage.getItem('_showMenuItemInstruction') == undefined){
    localStorage.setItem('_showMenuItemInstruction', true);
  }
  let _menuItemInstruction = localStorage.getItem('_showMenuItemInstruction') == 'true';
  let _notShowMenuItemInstruction = sessionStorage._notShowMenuItemInstruction ? sessionStorage._notShowMenuItemInstruction : '';

  if (_menuItemInstruction && _notShowMenuItemInstruction.search(venueId) == -1){
    if ($('#menu-order-instruction').length > 0) {
      let $div = $("#menu-order-instruction")
      let $clone = $div.clone()

      $clone.prop("id", "menu-order-instruction-pop-up")
      $clone.find('#collapse-learn-more').prop("id", "collapse-learn-more-pop-up").prop("class", "collapse in")
        .parent('div').removeClass()
      $clone.find('.btn-learn-more').prop("href", "#collapse-learn-more-pop-up").hide()

      let instructionHTML = $clone.html()

      let html = `
        <div id="modal-instruction" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <img class="header-logo" id="platerateLogo" src="/images/banner_platerate.png" alt="platerate logo">
                ${instructionHTML}
              </div>
              <div class="modal-footer" style="border-top: 0">
                <div id="footer-model-instruction" class="form-row" >
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      $('.modal-instruction-component').html(html);
      $('.modal-instruction-component').find('.circle-rating').addClass('ratecss');
      $('.modal-instruction-component').find('.ratecss').removeClass('circle-rating');
      $('#modal-instruction').on('click','#instruction-confirm', function(){
        saveSessionNotShowMenuItemInstruction()
        $("#modal-instruction").modal('hide')
      });
      $('#modal-instruction').on('click','#stop-showing-instruction-box', function(){
        localStorage.setItem('_showMenuItemInstruction', false);
        $("#modal-instruction").modal('hide')
      });
      $('#modal-instruction').on('click','.no-partner-restaurants', function(){
        saveSessionNotShowMenuItemInstruction()
        $("#modal-instruction").modal('hide');
        noCooperativeRestaurant();

      });
      $('#modal-instruction').on('click','.partner-restaurants', function(){
        saveSessionNotShowMenuItemInstruction()
        $("#modal-instruction").modal('hide');
        salecrmRestaurant();
      });
    }
  }
}

function saveSessionNotShowMenuItemInstruction(){
  if(sessionStorage._notShowMenuItemInstruction == null || sessionStorage._notShowMenuItemInstruction == undefined){
    sessionStorage._notShowMenuItemInstruction = venueId;
  }else{
    sessionStorage._notShowMenuItemInstruction += ','+venueId;
  }
}

function noCooperativeRestaurant(){
  let venueId =  $("#venueId").val();
  $.ajax({
    url: "/restaurantadmin/noCooperativeRestaurant",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      venueId: venueId,
      userId: venueId
    }),
    success: function (data) {
      if(data){
        if(data.code == 1){
          $('.no-partner-restaurants').attr('style','color: #d9534f !important;background: #fff !important;border: 1px solid #d9534f !important;');
          $('.no-partner-restaurants').removeClass('enable');
        }else{
          $('.no-partner-restaurants').attr('style','background: #d9534f !important;');
          $('.no-partner-restaurants').addClass('enable');
          if($('.partner-restaurants').hasClass('enable')){
            salecrmRestaurant();
          }
        }
      }
    }
  })
}

function salecrmRestaurant(){
  let venueId =  $("#venueId").val();
  $.ajax({
    url: '/salescrm/requestrestaurant',
    method: 'POST',
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      venueId: venueId
    }),
    dataType: 'json',
    error: function (err) {
      Swal.fire({
          title: "Request error !!!",
          text: 'Please try again!',
          icon: "error",
          confirmButtonText: "Yes",
          allowOutsideClick: true,
      });
    },
    success: function (data) {
      if(data){
        if(data.code == 1){
          $('.partner-restaurants').attr('style','color: mediumseagreen !important;background: #fff !important;border: 1px solid mediumseagreen !important;');
          $('.partner-restaurants').removeClass('enable');
        }else{
          $('.partner-restaurants').attr('style','');
          $('.partner-restaurants').addClass('enable');
          $('#request-platerate-contact').attr('disabled','disabled');
          if($('.no-partner-restaurants').hasClass('enable')){
            noCooperativeRestaurant();
          }
          $('#request-platerate-contact').off('click');
          Swal.fire({
              title: "Request success",
              text: 'PlateRate will try to work with this restaurant',
              icon: "success",
              confirmButtonText: "Yes",
              allowOutsideClick: true,
          });        
        }
      }
    }
  })
}



window.addEventListener('DOMContentLoaded', runOnScroll);
window.addEventListener('load', runOnScroll);
window.addEventListener('scroll', runOnScroll);
window.addEventListener('resize', runOnScroll);

  function getTab(tab) {
    let url = new URL(window.location.href);
    let show = url.searchParams.get(tab);
    return show;
  }



  /**
   * Get venue distance
   */
  localforage.getItem(venueParams.venueId + 'distance')
    .then(function (cachedVenue) {

      if (cachedVenue) {
        let venueDistance = cachedVenue;
        let element = $(`<span class="green">${venueDistance} mi</span>`);
        $('.venue-distance').html(element).append(' away');
      }
    })
    .catch(function (error) {
      //console.log('venue distance error', error);
    })

  //Show login message btn
  $('.show-login-btn').click(function () {
    //Redirect user to login page
    const action = $(this).data('action');
    swalRequiredLogin(action);
  })

  $('.show-login-btn-add-menu').click(function () {
    //Redirect login page
    const action = $(this).data('action');
    swalRequiredLogin(action, 'Please login or register to add menu item.');
  })

  function swalRequiredLogin(action = false, text = null) {
    Swal.fire({
      title: "Login Required",
      text: text || "Please login or register to upload images.",
      icon: "info",
      allowOutsideClick: true,
      confirmButtonText: "Login or Register",
      confirmButtonColor: "#3cb371"
    }).then((result) => {
      if (result.isConfirmed) {
        let urllogin = '/users/login';
        if (window.location.pathname && (window.location.pathname !== urllogin && window.location.pathname !== '/')) {
          urllogin = `${urllogin}?next=${window.location.pathname}`;
          if (action) saveAction(action);
        }
        window.location.assign(urllogin);
      }
    });
  }  

  // Submit ratings post request
  var submitRatings = function (ratings, ratingUrl, redirectUrl) {
    $.ajax({
      type: "POST",
      url: ratingUrl,
      dataType: "json",
      data: JSON.stringify(ratings),
      success: function (data) {
        try {
          window.location.assign(redirectUrl);
        } catch (error) {
        }
      }
    })
      .catch((e) => {
        console.error('Unable to submit ratings', e)
      })
  };

//redesign i dont think below is needed
  /*
   *   Setup hanler for expanding restaurant tree menu
   */
  $('#expandMenuBtn').on('click', function (event) {
    event.preventDefault();
    let status = $(this).data('status')
    if(status == 'close'){
      $(this).data('status', 'open')
      $("#favorites-menu-items").hide();
      $('#expandAll').text('Expand All');
      $(this).find('i').removeClass('fa-minus-circle')
      $(this).find('i').addClass('fa-plus-circle')
    }else{
      $(this).data('status', 'close')
      $("#favorites-menu-items").show();
      $('#expandAll').text('Close All');
      $(this).find('i').addClass('fa-minus-circle')
      $(this).find('i').removeClass('fa-plus-circle')
    }
  });


  /*
   *   Setup handler for dietary restrictions filter
   */

  $('#diet-prefs-reset-filter').click(function (event) {
    event.preventDefault();
    $('#dietary-restrictions-labels').addClass('hidden');
    $('#diet-prefs-filter').removeClass('hidden');
    $(this).addClass('hidden');
    /* redesign 15267
    $("#tree").fancytree("getTree").reload(dataTree).done(function(){
      expandAllNodes(true);
    });
    */
  });
  $('#diet-prefs-filter-no-prefs').click(function (event) {
    event.preventDefault();
    //Show no dietary preferences alert to user
    Swal.fire({
        title: "No Dietary Preferences Found",
        text: "You have not selected any dietary preferences. Please select preferences on your profile.",
        icon: "info",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonText: 'Dismiss',
        confirmButtonText: "Go To Profile",
        confirmButtonColor: "#3cb371"
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.assign('/users/healthy-eating-profile');
        }
    });  
  });


  /**
   * Highest rated menu item filter
   */
  $('#highest-rated-diet-prefs-reset-filter').click(function (event) {
    event.preventDefault();
    $(`.favorite-item`).show();
    $(`.favorite-item`).removeClass("grey-filter red-filter orange-filter green-filter");
    $('#highest-rated-dietary-restrictions-labels').addClass('hidden');
    $('#highest-rated-diet-prefs-filter').removeClass('hidden');
    $(this).addClass('hidden');
  });

  $('.btn-learn-more').on('click', function () {
      let $parent = $(this).parent('#menu-order-instruction')
      if($(this).hasClass('collapsed')) {
        $(this).html('Close')
      } else{
        $(this).html('Learn More')
      }
  });

  $('#highest-rated-diet-prefs-filter-no-prefs').click(function (event) {
    event.preventDefault();
    //Show no dietary preferences alert to user
    Swal.fire({
        title: "No Dietary Preferences Found",
        text: "You have not selected any dietary preferences. Please select preferences on your profile.",
        icon: "info",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonText: 'Dismiss',
        confirmButtonText: "Go To Profile",
        confirmButtonColor: "#3cb371"
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.assign('/users/healthy-eating-profile');
        }
    });  
  });

  //Get all matched DietaryPreferences
  function checkMatchedDietPreferences(menuitem) {
    return $.ajax({
      url: '/menuitem/findMenuItemDietPreferences',
      method: 'POST',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify({ entryId: menuitem }),
      dataType: 'json',
      error: function (err) {
        var itemError = {
          error: 'Error getting diet preferences',
          item: {
            entryId: menuitem,
            filterColorClass: 'grey',
          }
        };
        return itemError;
      }
    }).then(function (data) {
      return data;
    })
  }

  //\ Highest rated menu item filter
  /**
   * Select a spefic item from the restaurant menu
   */
   /* redesign do we need this
  const selectMenuItemFromTree = (itemId) => {
  alert("is selectemenuitemtree ever called");
    //Expand and select matching itemId
    $("#tree").fancytree("getTree").visit(function (node) {
      if (node.key === itemId) {
        node.setSelected();
        node.makeVisible();
      }
    });
  };
*/

  /*
   *   Setup handler for for venueName click
   */
  $('.venueName').on('click', function (event) {
    event.preventDefault();
    //Trigger the form post submit
    event.target.parentElement.submit();
  });

  /**
   * Accordions handlers
   * TODO: REVIEW
   */

  $('#restaurant-infor-collapse').on('shown.bs.collapse', function () {
    $('#restaurant-infor-accordion-icon').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
  });
  $('#restaurant-infor-collapse').on('hidden.bs.collapse', function () {
    $('#restaurant-infor-accordion-icon').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
  });

  // menu item infor
  $('#menu-item-infor-collapse').on('shown.bs.collapse', function () {
    $('#menu-item-infor-accordion-icon').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
  });
  $('#menu-item-infor-collapse').on('hidden.bs.collapse', function () {
    $('#menu-item-infor-accordion-icon').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
  });

  // /* For My Order accordion */
  // $('#collapseMyOrder').on('shown.bs.collapse', function () {
  //   $('#chevron_toggleable_myOrder').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
  // });
  // $('#collapseMyOrder').on('hidden.bs.collapse', function () {
  //   $('#chevron_toggleable_myOrder').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
  // });

  /* For My Orders accordion */
  $('#collapseMyOrders').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_myOrders').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
  });
  $('#collapseMyOrders').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_myOrders').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
  });

  /* For Menu Item Dietary Preference accordion */
  $('#collapseOne').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_one').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseOne').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_one').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Detailed Reviews accordion */
  $('#collapseTwo').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_two').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseTwo').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_two').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Detailed Taster Menu accordion */
  $('#collapseThree').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_three').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseThree').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_three').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Additional Restaurant Details accordion */
  $('#collapsefour').on('shown.bs.collapse', function (e) {
      if ($(this).is(e.target)) {
          $('#chevron_toggleable_four').addClass('fa-minus').removeClass('fa-plus');
      }
  });
  $('#collapsefour').on('hidden.bs.collapse', function (e) {
      if ($(this).is(e.target)) {
          $('#chevron_toggleable_four').addClass('fa-plus').removeClass('fa-minus');
      }
  });
  /* For Highest Rated Menu Items accordion */
  $('#collapseFive').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_five').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseFive').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_five').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Traditional Menu accordion */
  $('#collapseSix').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_six').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseSix').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_six').addClass('fa-plus').removeClass('fa-minus');
  });
  $('#collapseSeven').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_seven').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseSeven').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_seven').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Deals accordion */
  $('#collapseDeals').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_deals').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseDeals').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_deals').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For My Deals accordion */
  $('#collapseMyDealsT').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_myDealsT').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseMyDealsT').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_myDealsT').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For My Ratings accordion */
  $('#collapseMyRatings').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_myRatings').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseMyRatings').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_myRatings').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For My Ratings accordion */
  $('#collapseRestaurantReview').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_restaurantreview').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseRestaurantReview').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_restaurantreview').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Private Room  accordion */
  $('#collapsePrivateRooms').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_privateRooms').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapsePrivateRooms').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_privateRooms').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Restaurant admin accordion */
  $('#restaurantAdmin').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_restauran_admin').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#restaurantAdmin').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_restauran_admin').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For Free Food accordion */
  $('#collapseRestaurantCredit').on('shown.bs.collapse', function () {
    $('#free-food-arrow').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseRestaurantCredit').on('hidden.bs.collapse', function () {
    $('#free-food-arrow').addClass('fa-plus').removeClass('fa-minus');
  });

   /* For how to connect wifi */

   $('#accordion-connect-wifi').on('click', function() {
    if(!user_login) {
        Swal.fire({
          title: "A user has to register to PlateRate to see the wifi info for a restaurant.",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#3cb371",
          confirmButtonText: "Login/Register"
      }).then((result) => {
          if (result.isConfirmed) {
              const resTaurantId = !_.isEmpty(currentUrl.split('/restaurant/')) ? currentUrl.split('/restaurant/')[1] : '';
              window.location.replace(`/users/login?next=/restaurant/${resTaurantId}`);
          }
      });
    }
  });
  $('#collapseConnectWifi').on('shown.bs.collapse', function () {
    $('#connect-wifi-arrow').addClass('fa-minus').removeClass('fa-plus');
    const timeRestaurantAllow = Number($('#time-to-get-credit').text().trim()) || 1;
    const currentTime = new Date();
    const parts = document.cookie.split(';').find(part => part.includes('register='));
    let registerData = parts ? JSON.parse(parts.split('=')[1]) : {};
    const emailCurrentUser = $('#user-email').text().trim();
    const isSmallerOneHour = !_.isEmpty(registerData) ? (currentTime - new Date(registerData.timeRegister)) <= timeRestaurantAllow*60*60*1000 : false;
    if(emailCurrentUser === parts.email && isSmallerOneHour){
      // add 10% credit for user if connect wifi after registering not over 1 hour
    }
  });
  $('#collapseConnectWifi').on('hidden.bs.collapse', function () {
    $('#connect-wifi-arrow').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Give Restaurant Credit accordion */
  $('#collapseCreditToRestaurant').on('shown.bs.collapse', function () {
    $('#credit-restaurant-arrow').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseCreditToRestaurant').on('hidden.bs.collapse', function () {
    $('#credit-restaurant-arrow').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For Platerate Adminstration accordion */
  $('#platerateAdmin').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_platerateAdmin').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#platerateAdmin').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_platerateAdmin').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For My Agreement accordion */
  $('#collapseMyAgreement').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_myAgreement').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseMyAgreement').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_myAgreement').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Salesperson Settings accordion */
  $('#collapseSalesPersonSettings').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_salesPersonSettings').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseSalesPersonSettings').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_salesPersonSettings').addClass('fa-plus').removeClass('fa-minus');
  });
   /* For Direct Payment Settings accordion */
   $('#collapseDirectDeposit').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_DirectDeposit').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseDirectDeposit').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_DirectDeposit').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For view Private Room accordion */
  $('#collapseviewPrivateRooms').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_viewprivateRooms').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseviewPrivateRooms').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_viewprivateRooms').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For upload menu */
  $('#collapseUploadmenu').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_uploadMenu').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseUploadmenu').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_uploadMenu').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Restaurant */
  $('#collapseRestaurant').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_restaurant').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseRestaurant').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_restaurant').addClass('fa-plus').removeClass('fa-minus');
  });
  /* For Sales CRM */
  $('#collapseSalesCRM').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_salescrm').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseSalesCRM').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_salescrm').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For Mapping FDA */
  $('#collapseFDA').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_fda').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseFDA').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_fda').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For Orders accordion */
  $('#collapseRestaurantOrder').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_resOrder').addClass('glyphicon-chevron-down').removeClass('glyphicon-chevron-right');
  });
  $('#collapseRestaurantOrder').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_resOrder').addClass('glyphicon-chevron-right').removeClass('glyphicon-chevron-down');
  });

  /* For photo gallery accordion */
  $('#collapseTt').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_rp').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseTt').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_rp').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For My Ratings Restaurant and Menu Item Expert Review accordions */
  $('#restaurantExpertLink').click(function () {
    const restaurantDetailsAnchor = $(this);
    if (restaurantDetailsAnchor.attr('aria-expanded') === 'false' ||
      restaurantDetailsAnchor.attr('aria-expanded') === undefined) {
      restaurantDetailsAnchor.text('hide detailed restaurant review');
    } else {
      restaurantDetailsAnchor.text('show detailed restaurant review');
    }
  });
  $('.expert-link').click(function () {
    const menuItemDetailsAnchor = $(this);
    if (menuItemDetailsAnchor.attr('aria-expanded') === 'false' ||
      menuItemDetailsAnchor.attr('aria-expanded') === undefined) {
      menuItemDetailsAnchor.text('hide expert review');
    } else {
      menuItemDetailsAnchor.text('show expert review');
    }
  });

  /* For Edit Restaurant Admins accordion */
  $('#collapseEditRestaurnantAdmins').on('shown.bs.collapse', function () {
    $('#chevron_toggleable_editRestaurnantAdmins').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseEditRestaurnantAdmins').on('hidden.bs.collapse', function () {
    $('#chevron_toggleable_editRestaurnantAdmins').addClass('fa-plus').removeClass('fa-minus');
  });

  /* For Salespeole */
  $('#collapseSalespeople').on('shown.bs.collapse', function () {
      $('#chevron_toggleable_selespeople').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapseSalespeople').on('hidden.bs.collapse', function () {
      $('#chevron_toggleable_selespeople').addClass('fa-plus').removeClass('fa-minus');
  });

    /* For salse revenue share split */
    $('#collapserevenueshare').on('shown.bs.collapse', function () {
      $('#chevron_toggleable_sales_revenue_share').addClass('fa-minus').removeClass('fa-plus');
  });
  $('#collapserevenueshare').on('hidden.bs.collapse', function () {
      $('#chevron_toggleable_sales_revenue_share').addClass('fa-plus').removeClass('fa-minus');
  });

  /*
   *  Menu item details scripts
   */

  /**
   * Highest rated items Stars Sorting
   */


  // to price checkbox sort toggle.
      $('.multi-factor-sorting .price-sorting').on('click', 'input', function(e) {
      $('.multi-factor-sorting .price-sorting input').each(function() {
        if (this != e.target){
          $(this).prop('checked',false);
          $(this).removeClass('selected');
        } else{
          $(this).prop('checked',true);
        }
      });
    });



  $('.multi-factor-sorting').on('click','input',function(){
    let sortby = $(this).attr('data-sort');
    let sortbyName = $(this).attr('data-name');
 if (!userIsLoggedIn && (sortby == 'taste')) {
      Swal.fire({
          title: "Login Required",
          text: "Please log in to sort by " + sortbyName + ".",
          icon: "info",
          allowOutsideClick: true,
          cancelButtonText: 'Dismiss',
          confirmButtonText: "Ok",
          confirmButtonColor: "#3cb371"
      });
      return false;
    }

    $(this).toggleClass('selected');
    HighestRatedSort();
    RestaurantMenuSort();
  });

  function HighestRatedSort(){
    const $menuItems = $('body').find(".favorite-item");
    const sortsBy = getSortFields();
    if(sortsBy && sortsBy.length > 0 && $menuItems.length > 0 ){
      const sortHighest = function () {

        $menuItems.sort(function (a, b) {
          return sortFunction(sortsBy, a, b,false); //passing false because now the sorting is not for nodetree
        });
//       $menuItems.detach();
        $("#favorites-menu-items").append($menuItems);
//        console.log("sorted favorites...",$menuItems);
        //$menuItems.appendTo($("#favorites-menu-items"));//apppend the sorted array of elements to the DOM
      }
      sortHighest()
    };
  };





/* 200701 stateline diner issue
why do we have olddatatree
// ===========================
var olddataTree = dataTree;
  for (let i = 0; i <= olddataTree.length; i++) {
    if(olddataTree[i] && olddataTree[i].title) {
      optionMenu += '<option value="' + olddataTree[i].title + '">' + olddataTree[i].title +'</option>'
*/
  // -------------------------------------------
  // $('#menu-search').val('');
  let optionMenu = ''
  for (let i = 0; i <= dataTree.length; i++) {
    if(dataTree[i] && dataTree[i].title) {
      optionMenu += '<option value="' + dataTree[i].title + '">' + dataTree[i].title +'</option>'
      if(document.getElementById("menu-selection")){
        document.getElementById("menu-selection").innerHTML = optionMenu;
      }

    }
  }

  if($('#userId').length && document.getElementById("menuForPrftRprt")){
    document.getElementById("menuForPrftRprt").innerHTML = optionMenu;
    $('#menuForPrftRprt').select2({
      placeholder: "Select menu",
      allowClear: true
    });
  }


  $('#menuSections').select2({
    placeholder: "Section menu",
    allowClear: true
  });

  $('#menu-selection').select2({
    placeholder: "Section menu",
    allowClear: true
  });
function hasWhiteSpace(s) {

  return s.indexOf(' ') >= 0;
}

//stop page reload on search menu
$("body .form-row.mt-3 form").submit(function() {
    return false;
});

$(document).on('click','body #reset_restaurant_filter',function(){
  $("body #restaurant_search_filter_div #dietaryPreferences").val(null).trigger("change");
  $("body #restaurant_search_filter_div #menu-selection").val(null).trigger("change");
  var $x = $("body .i_rated");
  $x.prop("checked", true);
  $("body #i_rated").prop("checked", true);
  $("body #show-food-not-meet").prop("checked", true);
  $("body #rest_flavor_match").prop("checked", true);
  $("body #rest_highest_incentive").prop("checked", true);
  $("body #rest_lowest_price").prop("checked", false);
  $("body #rest_highest_price").prop("checked", false);
  $("body #rest_highest_rated").prop("checked", true);
  $("body #rest_filter_orderTypePickup").prop("checked", true);
  $("body #rest_filter_orderTypeDelivery").prop("checked", true);
  $("body #rest_filter_orderTypeOrderAhead").prop("checked", true);
  $("#other_rated").prop("checked", true);
  $("body #filter_reviews").prop("checked", false);
  $("body #show-food-not-meet").prop("checked", true);
  $("body #res_highest_flavour_match").prop("checked", false);
  var restSlider = $("input#price_search_rest").bootstrapSlider();
  restSlider.bootstrapSlider("setValue", [0, 100]);
  $("#priceRange_header .min-slider-handle").html("");
  $("#priceRange_header .max-slider-handle").html("");
  $('body .restaurant-filter-orderType li').removeClass('active');
  //get all the items back again
  filter_items_by_keys();
});


$('#menu-search').keypress(function (e) {
  if (e.which == 13) {
    filter_items_by_keys();
    return false;
   }
});
var typingTimer;                //timer identifier
var doneTypingInterval = 500;  //time in ms, 5 second for example


//on keyup, start the countdown
$(document).on('keyup','#menu-search',function(){

  clearTimeout(typingTimer);
  typingTimer = setTimeout(filter_items_by_keys, doneTypingInterval);
  $("#search_menu_icon").removeClass("fa-search");
  $("#search_menu_icon").addClass("fa-times crossbutton");
});

$(document).on('click','.crossbutton',function(){
   $('#menu-search').val('');
    $('#menu-search').trigger('input')

    //setTimeout(()=>{
    $('#menu-search').val();
    $(".menusubheading").show()
    $(".menuheading_parent").show()
    $(".menuheading").show();
    $(".menu-section").show();
    clearflag=true;
     filter_items_by_keys(clearflag);

  if(searchKey=='' || searchKey==null){
    $(".restaurant-menu-infor .col-md-6.col-12").show();
  }
  $("#search_menu_icon").removeClass("crossbutton");
  $("#search_menu_icon").removeClass("fa-times");
  $("#search_menu_icon").addClass("fa-search");
});

function filter_items_by_keys(clearflag){
  var priceVal = $('#price_search_rest').val();
  let arr = priceVal.split(',');
  let price_from=0;
  let price_to=0;
  if(arr && arr.length==2){
    price_from = parseInt(arr[0]);
    price_to = parseInt(arr[1]);
  }
  let filterDietPref = $('#dietaryPreferences').val();

  let maximum_flavour_match=80;
  if($('#maxflvrmatchid').text()!=null && $('#maxflvrmatchid').text()!=undefined){
     maximum_flavour_match= parseInt($('#maxflvrmatchid').text());
  }

  searchKey = $('#menu-search').val().toLowerCase().replace(/\s/g,'');
  filters = {
    i_rated : $("#i_rated").is(':checked'),
    price_search_rest:filters.price_search_rest,
    price_from: price_from,
    price_to: price_to,
    other_rated : $("#other_rated").is(':checked'),
    meets_foodmatch : $("#show-food-not-meet").is(':checked'),
    highest_flavour_match : $("#highest_flavour_match").is(':checked'),
    maximum_flavour_match: maximum_flavour_match,
    filter_reviews:$("#filter_reviews").is(':checked'),
    filterDietPref: filterDietPref
  }
  filterByKeys()
  if(clearflag!=true){
    filterByMenus()
  }
}
//on keydown, clear the countdown 
$('#menu-search').on('keydown', function () {
  clearTimeout(typingTimer);
});
$('#search_menu_icon').on('click',
  filter_items_by_keys
);
$('#apply_restaurant_filter').on('click',
  filter_items_by_keys
);


// $( "#menu-search" ).focus(function() {
//   let listTilte = [];
//   listOfNodes = {};
//   let menuitemData=$(".menuitemData");
//   $(".menuitemData").each(function(index,element){
//      let node=$(this).val();
//      if(node){
//       node=JSON.parse(node);
//       if(node.type == 'setup'){
//         return true
//       }
//       if(listOfNodes[node.key]){
//         if(typeof(node.name)  === "undefined") {
//         } else{
//           listTilte.push(node.name);
//         }
//       }
//       filterMenuItems(node);
//     }
//   })
//   // Autocomplete menu search
//   $( "#menu-search" ).autocomplete({
//     source: listTilte,
//     select:  _.debounce((e) => {
//       filterByKeys();
//       if(!_.size($("#menu-selection").val())) return
//       filterByMenus();
//     },500)
//   });
// });

// $("#menu-search").keypress(function(e){
//   if (!e) e = window.event;
//   if (e.keyCode == '13'){
//     $('#menu-search').autocomplete('close');
//     return false;
//   }
// });

   /* Show Item description remaining text */
   $('.btn-read-more').click(function(e) {
    $(this).parent().parent().find('.item-desc-more').show();
    $(this).parent().parent().find('.item-desc-less').hide();
    $(this).hide()
    $(this).parent().find('.btn-read-less').show()
  })

  $('.btn-read-less').click(function (e) {
      e.preventDefault();
      $(this).parent().parent().find('.item-desc-more').hide();
      $(this).parent().parent().find('.item-desc-less').show();
      $(this).hide();
      $(this).parent().find('.btn-read-more').show()
  })

function RestaurantMenuSort () {
    const sortFields = getSortFields();
    if (sortFields.length !== 0){
      sortMenu(dataTree, sortFields, function(){
      /* redesign not clear why below
        let type = [];
        sortFields.forEach(item=>{
          type.push('desc');
        })
        return type;
      */
      }());
    }
    /* not needed below in redesign
    if(dataTree && dataTree.length) {
//setting it in timeout so that the sort checkboxes show up checked while the data is being loaded
      setTimeout(function(){
        $tree.fancytree('getTree').reload(dataTree).done(function(){
          expandAllNodes(true);
        });
      }, 100);
    }
    */
  }


// Filter menu items
var listOfNodes = {};
var searchKey;
var filters ={
  price_search_rest:false //this gets set to true when price filter is clicked
};


 $('#price_search_rest').on('change', function(){
      filters.price_search_rest = true;
 });


  $('.multi-factor-sorting').find('button').addClass('selected');

// restaurant page fillter reset
  var maxFlavour = 80;
  var htmlvalue='';
   maxFlavour = $("#flavorMatchPercentForColorGreen").val();
       if(maxFlavour){
        htmlvalue=' <input class="input-filter slider-infl slider" id="maxFlavour" name="maxFlavour" type="range" min="0" max="100" value="'+maxFlavour+'" ><span id="maxflvrmatchid">'+maxFlavour+'</span>';
        $(".maxrestflvrmatch").html(htmlvalue);
        setTimeout(()=>{
          $('#maxFlavour').on('input',function(e){

            let flavorValue = Number($(this).val() || 0);
            $('#maxFlavour').val(flavorValue);
            $('#maxflvrmatchid').text(flavorValue);
            maxFlavour = flavorValue;

          });
        }, 100)
      }

 $('.restaurant-filter-orderType li').on('click', function(){
      $(this).toggleClass('active');
 });

function setParentNodes(node){
  listOfNodes[node.key]= true;
  if(!node.menuType){
    return
  }
  setParentNodes(node.menuType)
}
function setChildrenNodes(node){
  listOfNodes[node.key]= true;
  if(!node.children) return
  setParentNodes(node)
}


function filterByKeys(){
listOfNodes = {};
  let account = '';
    try {
      account = JSON.parse($('#account-infor').text());
    } catch (error) {
      account = false;
    }
    let filterData = [];
    if(account && account.dietaryPreferences){
      account.dietaryPreferences.forEach((item)=>{
        filterData.push(item.name);
      })
    }
    let unmatchedDiet = null;
    if(filters && filters.filterDietPref !=undefined && filters.filterDietPref.length > 0){
      unmatchedDiet = filters.filterDietPref.filter( function(n) { return !this.has(n) }, new Set(filterData) );
    }
    let menuitemList=$(".menuitemData");
    menuitemList.each(function(index,element){
     let node=$(this).val();
     if(node){
      node=JSON.parse(node);
      let itemId = $(element).attr('id');
      /* add a new selected diet pref to the dietary pref drawer */
      if(unmatchedDiet){
        let newdiethtml = filterDietPrefs(account, unmatchedDiet, node.key,'menu');
        if(itemId.startsWith("favorite")){
          $(".favorite-item #collapse-menu-item-"+node.key).append(newdiethtml);
        } else {
          $(".regular-menu #collapse-menu-item-"+node.key).append(newdiethtml);
        }
      }
      if(node.type == 'setup') return $(node).show();
      let showNode = filterMenuItems(node);
      if(listOfNodes[node.key]){
        let nodediv = $(node.key);
        if(nodediv) nodediv.display = 'inline';
        //remove hidden property

           $('#'+node.key).attr("hidden",false);
        $('#favorite_'+node.key).attr("hidden",false);
        $('#'+node.key).removeClass("hideitem").show();
        $('#favorite_'+node.key).removeClass("hideitem").show(); //show the same id in favorite section too
        $('#regular_'+node.key).removeClass("hideitem").show(); //show the same id in favorite section too
        if(!searchKey) return true
        let pattern = _.join(_.split(searchKey,''),'\\s{0,1}')
        let text = node.name;
        //let reg = new RegExp(`${pattern}`, 'gi');
        //let text = node.name.match(reg);
        if(_.size(text)){
          text = text[0];
          let newTitle = _.replace(node.name,text,`<mark>${text}</mark>`)
          nodediv.find('.favorite-item-name').html(newTitle);
        }
      } else {
        let nodediv = $(node.key);
        if(nodediv && node.type == "item") nodediv.display = 'none';
        if(node.type == "item"){
/* mangita, why this
          let listOfMenu = $("#menu-selection").val();
          var menusearch=$('#menu-search').val()
          if(listOfMenu.length>0 || menusearch!=''){
*/
            $('#regular_'+node.key).addClass("hideitem").hide() ;
            $('#favorite_'+node.key).addClass("hideitem").hide(); //hide the same id in favorite section too
//          }
          }
      }
    }
  })
}

function filterMenuItems(node){
   let myRate;
  let regex = /<\/{0,1}mark>/gi;
  let nodeTitle = _.toString(node.title).replace(regex,'');
  let nodeDesc = _.toString(node.description).replace(regex,'');
  let nodeMenu = _.toString(node.menuName).replace(regex,'');
  let nodeSection = _.toString(node.sectionName).replace(regex,'');
  node.title = nodeTitle;
//redesign   $(node.li).find('span.fancytree-title').find('span').html(nodeTitle);

  if(node.type == 'setup') return
  if(searchKey==''){
    $('#menu-search').val();
    $(".menusubheading").show()
    $(".menuheading_parent").show()
    $(".menuheading").show();
    $(".menu-section").show();
  }
  if(searchKey != ''){
    let nodeTitle = _.toString(node.title).replace(regex,'');
    nodeTitle = _.toLower(node.title).replace(/\s/g,'');
    nodeMenu = _.toLower(node.menuName).replace(/\s/g,'');
    nodeSection = _.toLower(node.sectionName).replace(/\s/g,'');
    nodeDesc = _.toLower(node.description).replace(/\s/g,'');
 
     // redesign
    if(!searchKey || nodeTitle.indexOf(searchKey) > -1 || nodeDesc.indexOf(searchKey) > -1 || nodeMenu.indexOf(searchKey) > -1 || nodeSection.indexOf(searchKey) > -1){
      setParentNodes(node)
      setChildrenNodes(node)
    }

  } else if(filters) {
      let showNode=true;
      /**** check current user's ratings ****/
      myRate = myRatings.filter((singleRating) =>
      {
        if(singleRating.menuItemId && singleRating.menuItemId == node.key){
          return true;
        }
      });
    //restaurant menu I have rated items
    if(node && node.rating == undefined){
      showNode = false;
    }else if(filters.i_rated == true && filters.other_rated == true){
    } else if(filters.i_rated == true && myRate.length == 0 && node.rating != 'undefined'){
      showNode=false;
    } else if(filters.other_rated == true && myRate.length>0){
      showNode=false;
    }

    if(filters.meets_foodmatch == true){ //dietary preference must meet
     //check if item don't match user restrictions to remove
      let elem = $(`#menu-meets-preferences-item-${node.key},#favorites-meets-preferences-item-${node.key}`);
      if(elem && elem.attr('class')) {
        let button_class = elem.attr('class').match(/cus-btn-red/g); //red class means not meeting
        if(button_class) {
          console.log("node doesnt meet diet pref coz of red color, hiding...", node.title);
          showNode = false;
        }
      } else {
        if(node.dontMatchUserRestrictions || node.filterColorClass =="red" ){
          console.log("node doesnt meet dier pref, hiding...", node.title);
          showNode = false;
        }
      }
    }
    //check for individual pref, above we are only looking for top
    let elems = $(`#collapse-menu-item-${node.key}`).find( ".item-preferences li.active" );
    if(elems && elems.length){
      elems.each(function( index ) {
        let tx = $( this ).text().trim()
        if(tx.toLowerCase()=="no"){
          showNode = false;
        }
      });
    }
    if(filters.highest_flavour_match == true){  //FlavorMatch
      const taste = node.flavorMatchitem ? Number(node.flavorMatchitem) : 0;

       if(Math.round(taste) < filters.maximum_flavour_match){
        showNode=false;
      }

    }

    if(filters.price_search_rest==true){
        if( Math.round(node.price)==0 ||  Math.round(node.price)<filters.price_from){
           showNode = false;
        }

        if( Math.round(node.price)==0 || Math.round(node.price)>filters.price_to){
          showNode = false;
        }
    }

    if(filters.filter_reviews==true){
      if( node.reviews ==null || Math.round(node.reviews)==0 ){
        showNode = false;
      }
    }

    if(showNode){
      setParentNodes(node);
      setChildrenNodes(node);
      return true;
    } else {
      //return listOfNodes[node.key]; //to hide the node
      return false;
    }
  }
  if(!node.children) return
  _.forEach(node.children,(element)=>{
    filterMenuItems(element)
  })
}

function expandNodes(node){
  if(!node) return
 // node.setExpanded(true)
  //expandNodes(node.parent)
}

//either filter based on selected menu and if none selected, and if searchterm
// then hide all headings, and sections if no menuitems visiblem under that
//hierarchy:menuheading_parent , menu-section(includes menusubheading), restaurant-menuitem
function filterByMenus(){
  let listOfMenu = $("#menu-selection").val(); //filter selected menu
  console.log("in filterByMenus with listOfMenu=",  listOfMenu);
  if(listOfMenu.length > 0){
  $(".menuheading").each(function(index,element){
     let nodeTitle=$(this).text();
     if(nodeTitle){
      if(!listOfMenu || listOfMenu.length==0 || (listOfMenu.length > 0 && _.includes(listOfMenu, nodeTitle.trim()))){
         let parent=element.closest("div .menuheading_parent")
  	 if(parent) {
  	   $(parent).show()
  	 }
      }else{
      //find the closest parent div and hide
         let parent=element.closest("div .menuheading_parent")
  	 if(parent) {
  	   $(parent).hide()
  	 }
         console.log("in filterByMenus hiding node coz it is not in menutype..",  nodeTitle);
      }
     }
  })
  return ;
  }
  //if no search term, return from here
  let searchterm = $("#menu-search").val();
  if(!searchterm) {
    $("#favorites-menu").show(); //this may have been hidden by the seacrh term filter
    return;
  }
//check if no selected menu for filter, hide all sections which have no matching menuitems
  let showFavoriteHeading = false; //handling separately since it is defined on top and not as part of the rest of the menu display
  $(".menuheading_parent").each(function(index,element){
     let nodeTitle=$(this).text();
     if(nodeTitle){
       nodeTitle = nodeTitle.trim();
     //check if any visible menuitem
       let showFlag = false;
       let sections = $(this).find(".menu-section");
$(".particular-menu-item").removeClass("d-block")
       if(sections.length ==0){
         let secmenuitems = $(this).find(".restaurant-menuitem ");
          secmenuitems.each(function(index2,element2){     //checking for all menuitems
           if(!($(element2).hasClass("hideitem"))){
             if($(element2).hasClass("favorite-item")){
               showFavoriteHeading = true;
             }
             showFlag = true;
             return
           }
         }); //end of menuitems
       } else {
         //if sectioncount=0, check for menuitems direct
         sections.each(function(index1,element1){     //checking for all subheadings
           let showFlagSection = false;
           let secmenuitems = $(this).find(".restaurant-menuitem ");
            secmenuitems.each(function(index2,element2){     //checking for all menuitems
             if(!($(element2).hasClass("hideitem"))){
               if($(element2).hasClass("favorite-item")){
                 showFavoriteHeading = true;
               }
               showFlagSection = true;
               showFlag = true;
               return
             }
           }); //end of menuitems
           if(showFlagSection){
             $(this).show()
           } else {
             console.log("in filterByMenus hiding section=",  $(this).text().trim().substring(0,20));
      	     $(this).hide()
           }
         }); //end of sections
       }
       if(showFlag){
      	    $(this).show()
       } else {
           console.log("in filterByMenus hiding parent=",  nodeTitle.substring(0,20));
    	    $(this).hide()
       }
     } //nodetitle
  }) //end of menuheadings
  //hide or show the top rating section heading
 if(showFavoriteHeading){
    $("#favorites-menu").show();
  } else {
    $("#favorites-menu").hide();
  }
}

//returns the html  to be appended to the diet pref block if any filtererd diet prf is not there in the account diet pref
function filterDietPrefs(account, unmatchedDiet, itemId,menuType){
  let dietHTML = ``;
  unmatchedDiet.forEach((ele)=>{
    dietHTML += `
        <div class="form-group item-preferences mb-0">
          <div class="foodpref-font">Is this dish ${ele}?</div>
          <ul class="select-suitable-list d-flex justify-content-between pl-0" data-item-id="${itemId}" data-preference="${ele}">
              <li class="select-suitable-dish text-center" style="background-color: #4caf50">
                  <a class="text-black" href="javascript:void(0)">Yes</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="mostly" style="background-color:white">
                  <a class="text-black" href="javascript:void(0)">Mostly</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="canrequest" style="background-color: white">
                  <a class="text-black" href="javascript:void(0)">Can Request</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="notsure" style="background-color: white">
                  <a class="text-black" href="javascript:void(0)">Not Sure</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="no" style="background-color: white">
                  <a class="text-black" href="javascript:void(0)">No</a>
              </li>
              <li class="select-suitable-dish text-center" data-value="na" style="background-color:white;">
                  <a class="text-black" href="javascript:void(0)">N/A</a>
              </li>
            </ul>
          </div>
        `;
  });
  return dietHTML;
}

  /**
   * Handler to go to restaurant menu
   */
  //On page load, Restaurant Menu opens up the menu options
  $('.go-to-where-order').on('click',function(){
    go_to_heighest_or_regular_menu()

  })

  function go_to_heighest_or_regular_menu(){
  //we want to stay at details section  $('html, body').animate({ scrollTop: $(".restaurant-menu-infor").offset().top }, 800);
  }
    const $NO_SALES_ON_THE_SYSTEM = $('#noSalesOnTheSystem');
  if(sessionStorage.action) {
    const action = sessionStorage.action;
    //this timeout is necessary for item added to order from homepage
    setTimeout(function(){
      $(`#${action}`).trigger("click");
    },1000)
    sessionStorage.removeItem('action');
  }


  function saveAction (action) {
    if (typeof(Storage) !== "undefined") {
      sessionStorage.action = action;
    }
  }

  /* Init fileInput */
  if ($('#fileInput').length) {
    $(function () {
      initS3FileUpload($('#fileInput'));
    });
  }

  /**
   * Prevent default action for no links
   */
  $('.no-link').on('click', (e) => {
    e.preventDefault()
  });

  $('#btn-request-full-menu').click(function() {
    if(!userId) return window.location.assign('/users/login');
    let data = {};
    data.venueId = $(this).data('venue-id');
    data.cancel_request = $(this).data('requested');
    $.ajax({
      url: "/therestaurant/requestFullMenu",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
      success: (res)=> {
        let my_request = _.size(res.data.my_request);
        let num_request = _.size(res.data.others_request);
        let _text = '';
        if(my_request){
            _text = `${num_request + 1} people requested the full menu be here`;
            $(this).data('requested', true);
        }else{
            _text = `I wish the full menu was here <span style="text-transform: none;">(${num_request} others do too)</span>`;
            $(this).data('requested', false);
        }
        $(this).html(_text);
        toastr.success("Request successfully");
      },
      error: (err)=> {
        toastr.error("Request failed");
      }
    })
  })
  // facebook share item rated
  $(document).on('click','.fb-share-custom',function(){
    let shareLink = $(this).children('.facebookShareLink').val();
    let menuItemId = $(this).children('#menuItemId').val()
    let fbAppId = $(this).children('#fbAppShareId').val()
    let reviewId = $(this).children('#review-id').val()
    let orderId = $(this).children('#orderId').val()
    let linkImageRating = $(`#fileInput-${orderId?`${orderId}-`:''}${menuItemId}`).parent().find('img').attr('src') // Get link share image on order restaurant
    let linkImageReview = $(`#item-review-${orderId?`${orderId}-`:''}${reviewId}`).find('img').attr('src')
    let ratingBox = $(this).parent('.social-share-container').parent().find('.starRating')

    $.getScript('https://connect.facebook.net/en_US/sdk.js', function(){
      FB.init({
        appId: fbAppId,
        cookie : true,
        xfbml : true,
        version: 'v3.2'
      });

      let userRated = ratingBox.val()
      let linkWithRating = userRated ? `${shareLink}${userRated === '-1' ? '' : `&rating=${userRated}`}` : shareLink
      let linkWithImage

      if (reviewId && linkImageReview) {
        if (linkImageReview === '/images/tempfood.png') {
          linkWithImage = linkWithRating
        } else {
          linkWithImage = `${linkWithRating}&image=${linkImageReview}`
        }
      } else if (linkImageRating) {
        if (linkImageRating === '/images/tempfood.png') {
          linkWithImage = linkWithRating
        } else {
          linkWithImage = `${linkWithRating}&image=${linkImageRating}`
        }
      } else {
        linkWithImage = linkWithRating
      }

      FB.ui({
        method: 'share',
        href: linkWithImage,
        hashtag: '#platerate',
        quote: '@platerate'
      });
    });
  });

/*********add to or remove from wishlist******/
   $(".fa-bookmark-o ,.fa-bookmark").on('click', function(events){
      addBookMark(events);
    });

  // Set Date for reply review
  var currentDateHTML = $('.user-info-reply').children('.get-date-client')
  var dateCurrentValue = moment().format('MM/DD/YYYY');
  currentDateHTML.append(dateCurrentValue)

  // Call API create comment
  function createReplyComment(comment){
    return $.promisedAjax({
      url   : '/users/profile/createReplyComment',
      type: 'POST',
      data: JSON.stringify(comment),
      contentType: 'application/json',
      dataType: 'json'
    })
  };

  function editReplyComment(commentEdited){
    return $.promisedAjax({
      url   : '/users/profile/editReplyComment',
      type: 'POST',
      data: JSON.stringify(commentEdited),
      contentType: 'application/json',
      dataType: 'json'
    })
  };

  // View more comment
  $('.view-more-comments').click(function () {
    let messageView = $(this).parent().find('.message-view').val()
    let isShow = $(this).parent().attr('aria-expanded')
    if (!isShow || isShow === 'false') {
      $(this).text('view less')
    } else {
      $(this).text(messageView)
    }
  })

  // Editor Comment
  $('.editor-comment').click(function () {
    $(this).parent().find('.quick-view-comment').hide()
    $(this).hide()
    $(this).parent().find('.form-edit-comment').show()
  })

  // Cancel edit comment
  $('.btn-cancel-edit').click(function () {
    let wrapperParent = $(this).parent().parent()
    wrapperParent.hide()
    wrapperParent.parent().find('.quick-view-comment').show()
    wrapperParent.parent().find('.editor-comment').show()
  })

  // Submit comment edited
  $('.btn-submit-edit').click(function () {
    let reviewId = $(this).parent().find('.review-id').val()
    let commentId = $(this).parent().find('.comment-id').val()
    let newComment = $(this).parent().parent().find('.textarea-edit-comment').val()
    let dateNow = new Date().toISOString()

    if (newComment === '') {
      toastr.error(`Please write your comment before posting it`);
    } else {
      let infoUpdated = {
        reviewId: reviewId,
        commentId: commentId,
        comment: newComment,
        updatedDate: dateNow
      }

      editReplyComment(infoUpdated)
      .then((res) => {
        let wrapperParent = $(this).parent().parent()
        wrapperParent.hide()
        wrapperParent.parent().find('.quick-view-comment').text(infoUpdated.comment)
        wrapperParent.parent().find('.quick-view-comment').show()
        wrapperParent.parent().find('.editor-comment').show()
        let updatedDateComment = moment(infoUpdated.updatedDate).format('MM/DD/YYYY');
        wrapperParent.parent().find('.show-date-comment').text(updatedDateComment)
      })
      .catch(function (e) {
        toastr.error(`Edit comment failure: ${e.message}`);
      })
    }
  })

  // Reply review function
  $('.btn-reply-comment').click( function () {
    let wrapperParent = $(this).parent()
    let commentSelector = wrapperParent.parent().find('.textarea-reply-review')
    let getComment = commentSelector.val().trim()

    if (getComment === '') {
      toastr.error(`Please write your comment before posting it`);
    } else {
      let newComment = {
        entryId : wrapperParent.find('.entry-id').val(),
        venueId : wrapperParent.find('.venueId-id').val(),
        menuItemId : wrapperParent.find('.menuitemId-id').val(),
        venueName : wrapperParent.find('.venueName').val(),
        userId: wrapperParent.find('.currentUserId').val(),
        userName: wrapperParent.find('.currentUserName').val(),
        comment: commentSelector.val().trim(),
        createdDate: new Date().toISOString()
      }

      createReplyComment(newComment)
      .then((res) => {
        let findWrapperComment = $(`#wrapper-comments-${newComment.entryId}`)
        let getReviewId = wrapperParent.find('.entry-id').val()
        let findViewComment = $(`#collapseViewMoreComments-${getReviewId}`)
        let dateNow = `${new Date(newComment.createdDate).getMonth() + 1}/${new Date(newComment.createdDate).getDate()}/${new Date(newComment.createdDate).getFullYear()}`
        let checkVenueName = newComment.venueName === '' ? '' : `From ${newComment.venueName},`
        let insertComment = `
        <div class="item-comment">
          <div class="user-comment-info">
            <span>${newComment.userName},</span>
            <span>${checkVenueName}</span>
            <span>${dateNow}</span>
          </div>
          <span>${newComment.comment}</span>
        </div>
        `
        if (findViewComment.length) {
          findViewComment.append(insertComment)
        } else {
          findWrapperComment.append(insertComment)
        }
        commentSelector.val('')
      })
      .catch(function (error) {
        toastr.error(`Create comment failure: ${error.message}`);
      })
    }
  })

  // Set default estimate time myorder
function getEstimateTime(){
  let delivery_term = $('#delivery-term').text();
  let pickup_term = $('#pickup-term').text();
  let delivery_time = 'EST. DELIVERY TIME ~ ';
  let pickup_time = 'EST. PICK UP TIME ~ ';
  let min_time, max_time;
  let terms = {
    delivery: 'EST. DELIVERY TIME ~ 1 - 1.5 hrs',
    pickup: 'EST. PICK UP TIME ~ 1 - 1.5 hrs'
  };
  if(delivery_term){
    try {
      delivery_term = JSON.parse(delivery_term);
      if(delivery_term.isDelivery){
          min_time = Number(delivery_term.deliveryMinTime);
          if(min_time < 60){
            delivery_time += `${min_time} min`
          }else{
            delivery_time += `${parseFloat(min_time/60).toFixed(1)} hrs`;
          }
          max_time = Number(delivery_term.deliveryMaxTime);
          if(max_time < 60){
            delivery_time += ` - ${max_time} min`
          }else{
            delivery_time += ` - ${parseFloat(max_time/60).toFixed(1)} hrs`;
          }
          terms.delivery = delivery_time;
      }
    } catch (error) {
      //
    }
  }
  if(pickup_term){
    try {
      pickup_term = JSON.parse(pickup_term);
      if(pickup_term.isPickupOrders){
          min_time = Number(pickup_term.pickupMinTime);
          if(min_time < 60){
            pickup_time += `${min_time} min`
          }else{
            pickup_time += `${parseFloat(min_time/60).toFixed(1)} hrs`;
          }
          max_time = Number(pickup_term.pickupMaxTime);
          if(max_time < 60){
            pickup_time += ` - ${max_time} min`
          }else{
            pickup_time += ` - ${parseFloat(max_time/60).toFixed(1)} hrs`;
          }
          terms.pickup = pickup_time;
      }
    } catch (error) {
      //
    }
  }
  return terms
}

let estimateTime = getEstimateTime()
$('.est-time-order').children('b').text(estimateTime.delivery)

// end document ready----------------------------------------
})

window.update_tree_data = (item_id, data)=>{
  function update_item_data(infor){
    _.forEach(infor, (item)=>{
      if(item.type == 'item' && item.key == item_id){
        _.forIn(data, (value, key)=>{
          item[key] = value
        })
        return true
      }
      if(_.size(item.children)) return update_item_data(item.children);
      return true;
    })
  }
  try {
    tree_data = JSON.parse($('#tree-data').val());
  }catch(err){
     return false
  }
  update_item_data(tree_data);
  return tree_data
}

//to scroll to menu item slug
$(function() {
  $(window).on("load", function() {

  setTimeout(function() {

  var urlParams = new URLSearchParams(window.location.search);
  const menuItemLink = urlParams.get('menuItemLink');

  if (menuItemLink) {
    const menuItemPosition = $(`.link-${menuItemLink}`).offset().top;
    console.log("menuItemPosition...",menuItemPosition)
    if (isMobile || $(window).width() < 600){
      $('html,body').animate({scrollTop: menuItemPosition - 260}, 900, 'swing')
    } else {
      $('html,body').animate({scrollTop: menuItemPosition - 80}, 900, 'swing')
    }
  }
  }, 4000)
    calculateVenueDistance();
  });
});
// --------------------------------------------------------------------------
function calculateVenueDistance(){
  let userLat = Cookies.get('posLat');
  let userLng = Cookies.get('posLon');
  let venueLat = $("#venue-lat").text();
  let venueLng = $("#venue-lng").text();
  let distance = _calculateDistance(userLat, userLng, venueLat, venueLng);
  $("#venue-calculated-distance").text(distance);

  // render restaurant distance on pickup order
  let pickupDistance = !isNaN(distance) ? `${distance} mi` : 'unknown';
  $("#pick-address-distance").text(pickupDistance);

  return distance;
}


function tabs_menu_time(){
  let data;
  try{
    data = JSON.parse(sessionStorage.menu_hour);
  }catch (err){
    console.log("in tabs menu_time...",err);
    return false;
  }
  let days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  let infor = [];
  _.forEach(data,(item)=>{
    let time = {
      menu: item.menuName
    };
    if(item.hours.anyTime){
      time.time = 'All Day';
    }else{
      let d = moment().day();
      let t = item.hours.days[days[d]];
      time.time = `${t.fromTime} - ${t.toTime}`;
    }
    infor.push(time)
  });

  _.forEach(MENU_TABS.tabs, (item)=>{
    let time = _.find(infor, (elem) => {return elem.menu == item.title})

    item.sub_title = time.time;
  })

//redesign  return __nav[MENU_TABS.key].update(MENU_TABS);
}

  $('#tree').on('click','.addon-unselectable',function(event){
    event.preventDefault();
    if($(this).find('input').prop('checked')) {
      return $(this).find('input').prop('checked',false);
    }
    let _id = $(this).data('item-id');
    $(`.addon-parent-id-${_id}.addon-unselectable input`).prop('checked',false);
    $(this).find('input').prop('checked',true);
  })



  function appenSlider(menuName, photo) {
    const canvas = document.createElement("canvas");
    canvas.width = 24;
    canvas.height = 24;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#FFCC00";
    ctx.font = "24px FontAwesome";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("\uf00e", 12, 12);
    const dataURL = canvas.toDataURL('image/png');
    const $container = $('body').find(`#image_carousel_${menuName.replace(/\s/g, '_')}`).css('cursor', 'url('+dataURL+'), auto');
    if($container && $container.length) {
      const $indicators = $container.find('.carousel-indicators').find('li');
      const index = $container.find('.carousel-indicators').find('li').length;
      $indicators.removeClass('active');
      $container.find('.carousel-indicators').append(`<li data-target="#image_carousel_${menuName.replace(/\s/g, '_')}" data-slide-to="${index}" class="active"></li>`)
      const $carousel_inner = $container.find('.carousel-inner');
      $carousel_inner.addClass('slider-menus');
      $carousel_inner.find('.no-image-menu').remove();
      $carousel_inner.find('.item').removeClass('active');
      $carousel_inner.append(`<div class="item active"><img src="${photo}" class="carousel-image"></div>`)
      setTimeout(() => {
        $PROGRESSBAR.css({width: '0%'}).text('');
        $('body').find(`#progress-${menuName.replace(/\s/g, '_')}`).hide();
      }, 5000);
    }
  }

  function renderMenuHours( data) {
    const menuHours = data.hours;
    let hasAdmin = false;
    if(userIsLoggedIn && userId && data.admin) {
      if(data.admin.hasAdmin) hasAdmin = data.admin.userAdmin;
      else hasAdmin = true;

    }

    let days_of_week = [
      {day:'M',from:'7:00pm',to:'11:00am',class:'mon', isAvailable: true},
      {day:'T',from:'7:00pm',to:'11:00am',class:'tue', isAvailable: true},
      {day:'W',from:'7:00pm',to:'11:00am',class:'wed', isAvailable: true},
      {day:'T',from:'7:00pm',to:'11:00am',class:'thu', isAvailable: true},
      {day:'F',from:'7:00pm',to:'11:00am',class:'fri', isAvailable: true},
      {day:'S',from:'7:00pm',to:'11:00am',class:'sat', isAvailable: true},
      {day:'S',from:'7:00pm',to:'11:00am',class:'sun', isAvailable: true}
    ];
    let i,fromTime,toTime;
    let minutes = ['00','15','30','45'];
    let apm = ['am','pm'];
    if(menuHours && menuHours.days) {
      const menuDays = menuHours.days;
      days_of_week.map((item)=>{
        item.from = menuDays[item.class].fromTime;
        item.to = menuDays[item.class].toTime;
      })
    }

    const hours = (time) => {
      let option = ''
      for (i = 1; i < 13; i++) {
        option = option + `<option value="${i}" ${i== time ? 'selected': '' }>${i}</option>`
      }
      return option;
    }

    const minutesampms = (time) => {
      let option = ''
      apm.forEach(function(ap){
        minutes.forEach(function(value){
          let minuteampm = value+ap
          option = option + `<option value=":${minuteampm}" ${minuteampm == time ? 'selected' : ''}>:${minuteampm}</option>`
        })
      })
      return option;
    }

    let select = '';
    let menuAvailable = true;
    days_of_week.forEach(function (item, index) {
      fromTime = item.from.split(':');
      toTime = item.to.split(':');
      if(menuHours && menuHours.days) {
        const menuDays = menuHours.days;
        menuAvailable = menuDays[item.class].isAvailable;
      }
      select = select + `
      <tr class="${item.class}">
          <td class="text-center">
            <a href="javascript:;" for="" class="form-control meu-day-label">${item.day}</a>
          </td>
          <td class="text-center">
            <label class="">
				<input type="checkbox"  class="menu-unavailable" data-day="${item.class}" ${menuAvailable ? 'checked' : ''}/>
				<span class="label-text" style="font-size: 16px !important;"></span></label>
          </td>
          <td class="text-center">
            <span class="custom-dropdown select-menu-hours" style="display: inline-flex;">
              <select class="form-control menu-from-hour" ${hasAdmin ? '' : 'disabled'} style="margin: 5px !important">
                ${hours(fromTime[0])}
              </select>
              <select class="form-control menu-from-minute" ${hasAdmin ? '' : 'disabled'} style="margin: 5px !important">
                ${minutesampms(fromTime[1])}
              </select>
            </span>
          </td>
          <td> - </td>
          <td class="text-center">
            <span class="custom-dropdown select-menu-hours" style="display: inline-flex;">
              <select class="form-control menu-to-hour" ${hasAdmin ? '' : 'disabled'} style="margin: 5px !important">
                ${hours(toTime[0])}
              </select>
              <select class="form-control menu-to-minute" ${hasAdmin ? '' : 'disabled'} style="margin: 5px !important">
                ${minutesampms(toTime[1])}
              </select>
            </span>
          </td>
      </tr>
      `;
    });
    
    // Event listener to toggle availability
    document.addEventListener("change", function (event) {
      if (event.target.classList.contains("menu-unavailable")) {
        let row = event.target.closest("tr");
        let selects = row.querySelectorAll("select");
    
      //  selects.forEach(select => {
       //   select.disabled = event.target.checked;
      //});
      }
    });
    
    const htmlMenuHours = `
    <td role="gridcell" colspan="7" class="setup-menu">
      <div class="group-setup-menu text-center">
        <div class="group-menu-hours" data-menu-name='${data.menuName}'>
          <div class="text-left">
            <h3 style="font-style: italic;">Hours this menu is served</h3>
            <label class="preference-items">
              <input type="checkbox" class="diet-options ${hasAdmin ? 'any-time-menu': ''}" ${hasAdmin ? '': 'disabled'} ${menuHours.anyTime ? 'checked': ''}>
              <span class="label-text black" style="font-size: 16px !important; color: #4a4a4a;">Served any time restaurant is open?</span>
            </label>
          </div>
          <br/>
          <div class="text-left menu-hours" style="display: ${menuHours.anyTime ? 'none': ''}">
            <p class="green text-menu-hours">This menu is being served now</p>
            <table width="100%" class="tbl-times table-hours-menu">
              <thead>
                <tr>
                  <th class="text-center">Hours</th>
                  <th class="text-center">Available</th>
                  <th class="text-center"><ins>From</ins></th>
                  <th class="text-center"></th>
                  <th class="text-center"><ins>To</ins></th>
                </tr>
              </thead>
              <tbody>
              ${select}
              </tbody>
            </table>
            <div class="form-group text-center" style="margin-top: 15px;">
              <button type="button" class="btn btn-mid ${hasAdmin ? 'btn-save-hours-menu' : 'hidden'}">Save</button>
            </div>
          </div>
        </div>
      </div>
    </td>`
    return htmlMenuHours
  }
